/**
 * @license
 * @qwik.dev/core 2.0.0-beta.36-dev+ce9db74
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as $e, isBrowser as ye } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as pe } from "@qwik.dev/core/preloader";

const me = !1;

const be = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const ve = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const _e = (t, n, e, s, o = !1) => {
    const r = ve(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const ge = (t, n, e) => {
    const s = ve(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Ee = (t, n, e) => ve(t, n, e) >= 0;

const Se = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const ke = t => typeof t === "object" && t !== null;

const Re = t => Array.isArray(t);

const Pe = t => typeof t === "string";

const Te = t => typeof t === "function";

const qe = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = be(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const Me = "<sync>";

const Ae = t => typeof t === "function" && typeof t.getSymbol === "function";

const Sh = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const xe = "q:type";

const Ie = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const Oe = 124;

const je = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const Le = "q:renderFn";

const Fe = "q:targetEl";

const Xe = "⚡️";

const De = "q:slot";

const We = "q:s";

const Ve = "[q\\:patch]";

const kh = "q:r";

const Rh = "q:rp";

const Ue = "q:style";

const ze = "style[q\\:style]";

const Be = ze + ",style[q\\:sstyle]";

const He = "q:sstyle";

const Je = "q:ctx";

const Qe = "q:brefs";

const Ye = (t, n) => t["qFuncs_" + n] || [];

const Ge = "q:base";

const Ke = "q:container-island";

const Ze = "/" + Ke;

const ts = "q:ignore";

const ns = "/" + ts;

const es = "q:container";

const ss = "/" + es;

const rs = "q:cursorBoundary";

const is = "q:template";

const os = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const ls = "http://www.w3.org/1999/xhtml";

const us = "http://www.w3.org/2000/svg";

const cs = "http://www.w3.org/1998/Math/MathML";

const fs = "qRender";

const as = "q:id";

const hs = "q:key";

const ds = "q:props";

const ps = "q:seq";

const $s = "q:seqIdx";

const ys = "q:p";

const ms = "q:ps";

const bs = ":on";

const vs = ":onIdx";

const _s = ":onFlags";

const gs = ":nearestCursorBoundary";

const Es = ":";

const Ss = "dangerouslySetInnerHTML";

const Rs = 100;

const Ps = t => !!t && typeof t == "object" && typeof t.then === "function";

const Ts = (t, n, e) => {
    try {
        const s = t();
        return Ps(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const qs = (t, n) => Ps(t) ? t.then(n) : n(t);

const Ms = t => {
    throw t;
};

function n(t, n = Ms) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!Ps(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = Rs;
    const r = async e => {
        for (;Ps(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!Ps(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const As = t => Xe + t;

const xs = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + As(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const Is = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + Ns(t.slice(s, -1));
        }
    }
    return null;
}

const Ns = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = Cs(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const Cs = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const Os = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const js = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const Ls = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const Fs = t => {
    if (!t) {
        return "";
    }
    if (Pe(t)) {
        return t.trim();
    }
    const n = [];
    if (Re(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = Fs(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const Xs = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

function s(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = Fs(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = (t => {
            if (t == null) {
                return "";
            }
            if (typeof t == "object") {
                if (Re(t)) {
                    throw qe(0, [ t, "style" ]);
                }
                {
                    const n = [];
                    for (const e in t) {
                        if (Object.prototype.hasOwnProperty.call(t, e)) {
                            const s = t[e];
                            s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(Xs(e) + ":" + Ds(e, s)));
                        }
                    }
                    return n.join(";");
                }
            }
            return t + "";
        })(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const Ds = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => js.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const Ws = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        e.port1.onmessage = () => t();
        n = () => e.port2.postMessage(null);
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const Vs = () => ({
    isServer: $e,
    importSymbol(t, n, e) {
        if ($e) {
            const t = Sh(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw qe(6, [ e ]);
        }
        if (!n) {
            throw qe(14, [ e ]);
        }
        if (!t) {
            throw qe(13, [ n, e ]);
        }
        const s = Us(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const Us = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(Ge) ?? s, s);
    return new URL(e, o);
};

let zs = /*#__PURE__ */ Vs();

const Bs = t => zs = t;

const Hs = () => zs;

const Ph = () => zs.isServer;

const Th = typeof document !== "undefined";

const Js = !$e && Th;

const Qs = Js ? document : void 0;

const Ys = Js && Qs.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

const Gs = /\.[mc]?js$/;

const Ks = 1e3 / 60;

const Zs = t => {
    let n = tr.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            Wt: t,
            Ot: Gs.test(t) ? 0 : 3,
            Vt: n,
            Ut: 1,
            zt: performance.now(),
            Bt: 0,
            Ht: 0
        }))(t, e);
        tr.set(t, n);
    }
    return n;
};

const tr = new Map;

let nr = 0;

const er = [];

const sr = Ws(function qh() {
    ir = !1;
    if (!er.length) {
        return;
    }
    const t = performance.now() + Ks;
    let n = !1;
    for (;er.length; ) {
        const e = er[0];
        const s = e.Ut;
        const o = 1 - s;
        if (!(o >= .99 || nr < 25)) {
            break;
        }
        er.shift();
        fr(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && er.length && !ir) {
        ir = !0;
        sr();
    }
});

const rr = Ws(r);

let ir = !1;

let or = !1;

let lr = !1;

const ur = [];

const cr = () => {
    const t = ur[ur.length - 1];
    const n = t.Jt;
    if (t.Vt) {
        const e = t.Qt;
        if (e >= t.Vt.length) {
            ur.pop();
            return !1;
        }
        const s = t.Vt[e];
        t.Qt = e + 1;
        const o = Zs(s.Wt);
        if (o.Ut === 0) {
            return !0;
        }
        const r = 1 - n.Ut;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s.Yt);
        } else {
            const t = 1 - s.Yt * r;
            const n = s.Gt;
            const e = t / n;
            i = Math.max(.02, o.Ut * e);
            s.Gt = e;
        }
        ur.push({
            Jt: o,
            Ut: i,
            Kt: t.Kt
        });
        return !0;
    }
    if (t.Kt?.has(n)) {
        ur.pop();
        return !1;
    }
    const e = n.Ut;
    n.Ut = t.Ut;
    if (e - n.Ut < .01) {
        ur.pop();
        return !1;
    }
    if (n.Vt?.length) {
        const e = t.Kt || new Set;
        e.add(n);
        t.Kt = e;
        t.Vt = n.Vt;
        t.Qt = 0;
        return !1;
    }
    ur.pop();
    return !1;
};

function r() {
    if (lr || !ur.length) {
        return;
    }
    or = !1;
    lr = !0;
    const t = Js ? performance.now() + Ks : 0;
    let n = !1;
    for (;ur.length; ) {
        n = !0;
        const e = cr();
        if (Js && e && performance.now() >= t) {
            if (!or) {
                or = !0;
                rr();
            }
            break;
        }
    }
    lr = !1;
    n && Js && sr();
}

const fr = t => {
    if (t.Ot >= 2) {
        return;
    }
    nr++;
    const n = performance.now();
    t.Bt = n - t.zt;
    t.Ot = 2;
    const e = Qs.createElement("link");
    e.href = new URL("undefined" + t.Wt, Qs.baseURI).toString();
    e.rel = Ys;
    e.as = "script";
    e.onload = e.onerror = () => {
        nr--;
        const s = performance.now();
        t.Ht = s - n;
        t.Ot = 4;
        e.remove();
        sr();
    };
    Qs.head.appendChild(e);
};

const ar = (t, n) => {
    const e = Zs(t);
    e && ((t, n) => {
        ur.unshift({
            Jt: t,
            Ut: n,
            Kt: void 0
        });
    })(e, n);
};

Js && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    ar(e, 0);
                }
            } else {
                ar(t, 0);
            }
            Js ? rr() : r();
        })(t);
    }
});

const hr = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const dr = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    }
});

const pr = '"';

const $r = "[";

const yr = "]";

const mr = ",";

const wr = "2.0.0-beta.36-dev+ce9db74";

const br = t => t.nodeType === 1;

const Mh = t => t.Cn;

const vr = Symbol();

class _r {
    [vr]=void 0;
}

const gr = t => t === "foreignObject";

const Er = t => t === "svg" || gr(t);

const Sr = t => t === "math";

function i(t, n, e, s = !1) {
    const o = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== Es && o.setAttribute(e.name, e.value);
    }
    if (s) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const r = t.childNodes[n];
            const c = r.nodeType;
            c === 3 ? o.appendChild(r.cloneNode()) : c === 1 && o.appendChild(i(r, r.localName, e, s));
        }
    }
    return o;
}

const kr = {
    elementNamespace: ls,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!El(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && gr(El(t));
    let o = ls;
    let r = 0;
    const i = typeof n === "string" || zo(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return Er(t);
        }
        if (zo(t)) {
            return Er(El(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = us;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return Sr(t);
        }
        if (zo(t)) {
            return Sr(El(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = cs;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? us : e ? cs : ls;
        r = t.flags & 1536;
    }
    kr.elementNamespace = o;
    kr.elementNamespaceFlag = r;
    return kr;
}

class Rr {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [vr]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class Pr extends Rr {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class Tr extends Pr {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class qr extends Rr {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const Mr = [];

const Ar = [];

function l(t, n) {
    const e = y(n).priority;
    let s = Mr.length;
    for (let t = 0; t < Mr.length; t++) {
        const n = y(Mr[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Mr.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < Mr.length; t++) {
        const n = Mr[t];
        let e = !1;
        for (let t = 0; t < Ar.length; t++) {
            const s = Ar[t];
            if (zl(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    Ar.push(t);
    h(t, n, !0);
    n.o++;
}

function f(t, n) {
    d(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    l(n, t);
}

function a(t, n, e) {
    const s = y(e);
    if (!s || s === n) {
        return;
    }
    h(e, t, !1);
    d(e, t);
    $(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function h(t, n, e) {
    e || (t.flags &= -257);
    const s = Mr.indexOf(t);
    if (s !== -1) {
        Mr.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function d(t, n) {
    const e = Ar.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = Ar.length - 1;
    e !== s && (Ar[e] = Ar[s]);
    Ar.pop();
    n.o--;
    return !0;
}

const xr = new WeakMap;

const Ir = ":nodeProps";

const Nr = ":nodeDiff";

const Cr = ":errorData";

const Or = ":signal";

const jr = ":inlineComponentData";

function p(t, n, e) {
    n.position = e;
    e && cn(e) && function s(t, n, e) {
        h(e, t);
        const s = y(e);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            $(t, n);
        })(n, s);
    }(t, n, e);
}

function $(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function y(t) {
    return xr.get(t) ?? null;
}

const Lr = Symbol();

class Fr {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const Xr = Symbol();

const Dr = Symbol();

const Wr = Symbol();

function m(t, n, e) {
    t[vr] || ($e && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(Qe, new Map) : t[vr] = new Map);
    const o = t[vr];
    let r = o.get(n);
    if (!r) {
        r = new Fr(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const Vr = (t, n) => (e, s) => {
    const o = he();
    o.Ft = m(t, ":");
    o.$ = n || void 0;
    return ce(o, () => {
        if (Te(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (iu(e)) {
            return e.value;
        }
        if (ke(e) && vu(e)) {
            qn(yu(e), Wr, $u(e), o.Ft);
            return e;
        }
        throw qe(2);
    });
};

class Ur {
    Zt;
    ct=void 0;
    $=null;
    tn=null;
    constructor(t, n) {
        this.$ = t || ef()?.$ || null;
        this.Zt = n;
    }
    trigger() {
        fu(this.$, this, this.ct);
    }
    force() {
        fu(this.$, this, this.ct);
    }
    get untrackedValue() {
        return this.Zt;
    }
    set untrackedValue(t) {
        this.Zt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = ef();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.Ft;
        if (e) {
            const t = $e;
            const s = this.ct ||= new Set;
            const o = __EXPERIMENTAL__.suspense && t;
            ou(s, e);
            lu(e, this);
            if (t) {
                const t = cu(n.$, this.$);
                o && t?.nn?.(this, e, null);
                uu(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.Zt) {
            this.Zt = t;
            fu(this.$, this, this.ct);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Zt
        };
    }
}

class zr extends Ur {
    en;
    h;
    [vr]=void 0;
    constructor(t, n, e = 17) {
        super(t || ef()?.$, Lr);
        this.en = n;
        this.h = e;
    }
    invalidate() {
        this.h |= 1;
        const t = he();
        t.$ = this.$ || void 0;
        const e = n(fe.bind(this, t, this.p));
        e && e.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get untrackedValue() {
        this.p();
        return this.Zt;
    }
    set untrackedValue(t) {
        this.Zt = t;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = this.en;
        ru(t);
        const n = ef();
        const e = n?.Ft;
        if (n) {
            const t = m(this, ".");
            gn(this.$, t);
            n.Ft = t;
        }
        try {
            const e = t.getFn(n)();
            if (Ps(e)) {
                throw qe(29, [ t.dev ? t.dev.file : "", t.it ]);
            }
            this.h &= -2;
            super.value = e;
        } finally {
            n && (n.Ft = e);
        }
    }
}

class Br {
    sn;
    rn=null;
    ln=!1;
    un=!0;
    constructor(t, n, e) {
        this.sn = t;
        if (n !== void 0) {
            this.info = n;
            this.cn = e;
        }
    }
    get track() {
        return this.fn ||= Vr(this.sn, this.sn.$);
    }
    get abortSignal() {
        return (this.an ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.sn.Zt;
        if (t !== Lr) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.hn ||= []).push(t);
    }
}

class Hr extends zr {
    dn=!1;
    pn=void 0;
    $n=null;
    [vr]=void 0;
    constructor(t, n, e = 17, s) {
        super(t, n, e);
        if (!s) {
            return;
        }
        const o = s.initial;
        if (o !== void 0) {
            const t = typeof o === "function" ? o() : o;
            this.Zt = t;
        }
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.yn = r;
            this.mn = [];
        }
        const i = s.timeout;
        i && (this.wn = i);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 64);
        s.allowStale === !1 && (this.h |= 128);
        const c = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        c && (this.expires = c);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    get untrackedValue() {
        this.p();
        if (this.$n?.rn) {
            if (this.Zt === Lr || $e) {
                throw this.$n?.rn;
            }
            return this.Zt;
        }
        if (this.pn) {
            throw this.pn;
        }
        if ($e && this.h & 64 && this.Zt === Lr) {
            throw qe(35);
        }
        return this.Zt;
    }
    set untrackedValue(t) {
        this.Zt = t;
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedLoading = !1;
        this.untrackedError = void 0;
        this.bn = void 0;
        if (this.mn) {
            for (let t = 0; t < this.mn.length; t++) {
                this.mn[t].un = !1;
            }
        } else {
            this.$n && (this.$n.un = !1);
        }
        this.vn();
        super.value = t;
        this._n();
    }
    get loading() {
        const t = this.untrackedLoading;
        const n = ef();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Ft;
            if (t) {
                ou(this.$t ||= new Set, t);
                lu(t, this);
                uu(t, this.$);
            }
        }
        return t;
    }
    set untrackedLoading(t) {
        if (t !== this.dn) {
            this.dn = t;
            fu(this.$, this, this.$t);
        }
    }
    get untrackedLoading() {
        this.p();
        if ($e && this.$n?.rn) {
            throw this.$n?.rn;
        }
        return this.dn;
    }
    get error() {
        const t = this.untrackedError;
        const n = ef();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.Ft;
            if (t) {
                ou(this.yt ||= new Set, t);
                lu(t, this);
                uu(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.pn) {
            this.pn = t;
            fu(this.$, this, this.yt);
        }
    }
    get untrackedError() {
        return this.pn;
    }
    get expires() {
        return this.Pt || 0;
    }
    set expires(t) {
        this.vn();
        this.Pt = t;
        this.Pt && this.gn() && this._n();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.Pt && this.gn()) {
            this.vn();
            this._n();
        }
    }
    get interval() {
        const t = this.Pt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    async invalidate(t) {
        if (arguments.length > 0) {
            this.bn = t;
            this.cn = this.cn === void 0 ? 1 : this.cn + 1;
        }
        this.En(!0, this.h & 128);
    }
    En(t, n) {
        this.h |= 1;
        this.vn();
        n && (this.Zt = Lr);
        t && (this.ct?.size || this.$t?.size || this.yt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.$n && this.Sn(this.$n, t);
    }
    wt() {
        if (!(this.h & 32) || this.gn()) {
            return;
        }
        if (!ye) {
            return;
        }
        setTimeout(() => {
            this.gn() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.$n?.rn; ) {
            await (this.$n?.rn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if ($e && this.h & 64) {
            this.dn = !0;
            this.$?.serializationCtx.Tt.add(this);
            return;
        }
        this.vn();
        this.h &= -2;
        const t = this.$n;
        t && this.Sn(t);
        const n = this.yn === 0 ? Infinity : this.yn ?? 1;
        if (this.mn ? this.mn.length >= n : t?.rn) {
            this.h |= 1;
            return;
        }
        const e = this.cn;
        const s = new Br(this, this.bn, e);
        this.$n = s;
        this.mn && this.mn.push(s);
        s.rn = this.kn(s);
    }
    async kn(t) {
        let e = this.en.resolved;
        if (!e) {
            this.untrackedLoading = !0;
            e = await this.en.resolve();
            if (t.an?.signal.aborted) {
                t.rn = null;
                return;
            }
        }
        try {
            this.wn && (this.Rn = setTimeout(() => {
                const n = Error(`timeout ${this.wn}ms`);
                this.Pn(t, n);
                t.an?.abort(n);
            }, this.wn));
            const s = n(e.bind(null, t));
            let o;
            if (Ps(s)) {
                this.untrackedLoading = !0;
                o = await s;
            } else {
                o = s;
            }
            t.rn = null;
            if (t.un) {
                const n = this.mn;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].un = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = o;
            }
        } catch (n) {
            t.rn = null;
            this.Pn(t, n);
        }
        if ((() => t === this.$n)()) {
            clearTimeout(this.Rn);
            t.cn === this.cn && (this.bn = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedLoading = !1;
                this._n();
            }
        }
    }
    Pn(t, n) {
        if (t !== this.$n || !t.un) {
            return;
        }
        t.un = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = Lr;
    }
    async Tn() {
        this.vn();
        clearTimeout(this.Rn);
        const t = this.$n;
        t && this.Sn(t);
        this.mn ? await Promise.all(this.mn.map(t => t.rn)) : await (t?.rn);
    }
    vn() {
        if (this.qn !== void 0) {
            clearTimeout(this.qn);
            this.qn = void 0;
        }
    }
    _n() {
        if ($e || !this.Pt) {
            return;
        }
        this.vn();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.qn = setTimeout(() => this.En(t, n), this.Pt);
        this.qn?.unref?.();
    }
    gn() {
        return !!(this.ct?.size || this.$t?.size || this.yt?.size);
    }
    Sn(t, n) {
        if (t.ln) {
            return;
        }
        t.ln = !0;
        t.an?.abort(n);
        t.rn = qs(t.rn, () => this.Mn(t));
    }
    Mn(t) {
        const n = t.hn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        const s = () => {
            t.rn = null;
            n && (n.length = 0);
            const e = this.mn;
            if (e) {
                const n = e.indexOf(t);
                n !== -1 && e.splice(n, 1);
            }
            this.p();
        };
        let o;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const s = n[t]();
                    Ps(s) && (o = (o ? o.then(() => s) : s).catch(e));
                } catch (t) {
                    e(t);
                }
            }
        }
        if (o) {
            return o.then(s);
        }
        s();
    }
}

const Jr = Symbol();

const Qr = Symbol();

const Yr = Symbol();

const Gr = Symbol();

const Kr = Symbol();

const Zr = Symbol();

const ti = [];

const ni = {};

Object.freeze(ti);

Object.freeze(ni);

function w(t) {
    return new Proxy({}, new ei(t));
}

class ei {
    owner;
    ct=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === Jr) {
            return this.owner.constProps;
        }
        if (n === Qr) {
            return this.owner.varProps;
        }
        if (n === Yr) {
            return this.owner;
        }
        if (n === Gr) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = ii(this.owner, n);
            n in this.owner.varProps && si(this, n);
        }
        return s instanceof ki && s.h & 4 ? s.value : s;
    }
    set(t, n, s) {
        if (n === Yr) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === Jr) {
            this.owner.constProps = s;
        } else if (n === Qr) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === ni ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                ri(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && ri(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === Jr || n === Qr) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && si(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const si = (t, n) => {
    const e = ef();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.Ft;
    s && qn(t.owner._proxy, n, t, s);
};

const ri = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ct, n);
    e && fu(t.$, t, e);
    return !!e;
};

const ii = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const oi = (t, n) => li(t)?.[n] || ui(t)?.[n] || null;

const li = t => {
    if (!t) {
        return null;
    }
    return Qr in t ? "children" in t ? {
        ...t[Qr],
        children: t.children
    } : t[Qr] : t;
};

const ui = t => {
    if (!t) {
        return null;
    }
    return Jr in t ? t[Jr] : null;
};

const ci = t => t && Qr in t;

const fi = t => (n, ...e) => t.call(null, Lf(n), ...e);

class ai extends zr {
    constructor(t, n) {
        super(t, n, 17);
    }
    An=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        ru(this.en);
        const t = lf(this.en.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Zt === Lr ? e : this.Zt;
        const r = cf(() => this.An ? s?.(o) || o : n(o), this, ".", this.$);
        this.An = !0;
        this.h &= -2;
        const i = this.An && r !== "undefined" || r !== this.Zt;
        if (i) {
            this.Zt = r;
            fu(this.$, this, this.ct);
        }
    }
}

const hi = (t, n) => new zr(n?.container || null, t, hu(n?.serializationStrategy || "always"));

const di = (t, n) => new Hr(n?.container || null, t, hu(n?.serializationStrategy || "always"), n);

const pi = t => new ai(null, t);

const $i = t => new Ur(null, t);

const yi = /*#__PURE__*/ fi(hi);

const mi = /*#__PURE__*/ fi(di);

const wi = fi(pi);

const bi = t => t.value;

const vi = (t, n) => t[n];

const _i = t => {
    if (t.length === 1) {
        if (iu(t[0])) {
            return t[0].tn ||= new ki(null, bi, t, null);
        }
        if (vu(t[0])) {
            return new ki(null, bi, t, null);
        }
        return t[0].value;
    }
    return new ki(null, vi, t, null);
};

const gi = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!ke(n)) {
        return n[e];
    }
    if (iu(n)) {
        if (n instanceof ki && n.h & 4) {
            return n;
        }
        return _i(t);
    }
    if (ci(n)) {
        const s = n[Jr];
        const o = n[Qr];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return Ei(n, t);
        }
    } else {
        const s = yu(n);
        if (s) {
            const n = s[e];
            return Ei(n, t);
        }
    }
    return n[e];
};

const Ei = (t, n) => iu(t) ? t : _i(n);

const Si = (t, n) => {
    const e = gi(t, n);
    if (e === Kr) {
        return t[n];
    }
    return e;
};

class ki extends Ur {
    lt;
    ot;
    kt;
    h;
    m=void 0;
    [vr]=void 0;
    constructor(t, n, e, s, o = 5) {
        super(t, Lr);
        this.lt = e;
        this.ot = n;
        this.kt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this.m) {
                this.$.setHostProp(this.m, Or, this);
                hn(this.$, this.m, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            fu(this.$, this, this.ct);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Zt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = cf(() => this.ot(...this.lt), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Zt;
        if (n) {
            this.h |= 2;
            this.Zt = t;
        }
    }
    rt() {
        return this.ot === bi && iu(this.lt[0]) ? this.lt[0] : this;
    }
    set value(t) {
        throw qe(31);
    }
    get value() {
        return super.value;
    }
}

class Ri {
    data;
    constructor(t) {
        this.data = t;
    }
}

Object.prototype.hasOwnProperty;

class Pi {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || hr(n) ? ni : n;
        this.constProps = !e || hr(e) ? null : e;
    }
    get props() {
        return this._proxy ||= w(this);
    }
}

const Ti = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const qi = t => t instanceof Pi;

const Mi = (t, n) => {
    if (typeof t === "string") {
        const e = se(n);
        kf(Rf(e, t));
    }
    return null;
};

function b(t, n) {
    Mi(this, n);
    const e = Sf[0];
    e.value = n.type === "number" ? n.valueAsNumber : n.value;
}

function v(t, n) {
    Mi(this, n);
    const e = Sf[0];
    e.value = n.checked;
}

function _(t, n) {
    Mi(this, n);
    if (Sf) {
        for (let t = 0; t < Sf.length; t++) {
            const n = Sf[t];
            n instanceof Hr && n.h & 64 && n.p();
        }
    }
}

const Ai = "bind:value";

const xi = "bind:checked";

const Ii = "passive:";

const Ni = "preventdefault:";

const Ci = Object.prototype.hasOwnProperty;

const Oi = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(Ns(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const ji = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return Ns(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return Ns(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return Ns(t.slice(11, -1));
    }
    return null;
};

const Li = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = ji(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const Fi = (t, n, e, s, o, r, i) => new Pi(t, n, e, s, o, r, !1, i);

const Xi = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(Ii)) {
                    r.push(o);
                    t.add(Ns(o.slice(8)));
                } else {
                    o.startsWith(Ni) ? h.push(o) : ji(o) !== null ? s.push(o) : o === xi ? a = e[o] : o === Ai && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(Ii)) {
                    i.push(s);
                    t.add(Ns(s.slice(8)));
                } else {
                    s.startsWith(Ni) ? d.push(s) : ji(s) !== null ? o.push(s) : s === xi ? a = n[s] : s === Ai && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = Oi(e, r, h, t, l);
            l = l || e !== n;
            e = Li(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = Oi(n, i, d, t, u);
            u = u || n !== e;
            n = Li(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && Ci.call(n, xi) && delete n[xi];
                if (e && Ci.call(e, xi)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[xi];
                }
                n.checked = a;
                const t = Mf(null, "_chk", v, null, [ a ]);
                if (e && Ci.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Ti(n, "q-e:input", t) || c;
                }
                c = Ti(n, "q-e:input", t) || c;
            } else if (f) {
                n && Ci.call(n, Ai) && delete n[Ai];
                if (e && Ci.call(e, Ai)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Ai];
                }
                n.value = f;
                const t = Mf(null, "_val", b, null, [ f ]);
                if (e && Ci.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Ti(n, "q-e:input", t) || c;
                }
                c = Ti(n, "q-e:input", t) || c;
            }
        }
        if (n && Ci.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && Ci.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new Pi(t, n, e, s, o, r, c || !0, i);
};

const Di = (t, n, e, s) => zi(t, n, s);

const Wi = (t, n, e, s, o) => zi(t, {
    ...e,
    ...n
}, o);

const Vi = (t, n, e, s, o, r) => zi(t, {
    ...e,
    ...n,
    children: s
}, r);

const Ui = t => t.children;

const zi = (t, n, e, s, o) => Xi(t, n, null, null, 0, e, o);

const Bi = zi;

const Hi = zi;

function g(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return Xi(t, n, null, s.children, 0, o);
}

const Ji = t => t.children;

const Qi = (t, n) => new Pi(Ui, null, null, t.children, 0, n);

const Yi = t => Fi(Ui, null, {
    [We]: ""
}, t.children, 0, t.name ?? "");

const Gi = Symbol();

const Ki = () => null;

const Zi = () => null;

const to = t => t.children;

const no = (t, n) => zi(Qi, {
    children: zi(eo, t)
}, n);

const eo = () => null;

let so = null;

let ro = null;

function E(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    ro || (ro = t.setAttributeNS);
                    ro.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            so || (so = t.setAttribute);
            so.call(t, n, e);
        })(t, n, e);
    }
}

const io = Object.prototype.hasOwnProperty;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const oo = (t, n = [], e = {}) => {
    let s = null;
    const o = t[Jr];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[Qr];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return w(new Pi(null, r, s, null, 0, null));
};

function k(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && io.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof ki) {
            return ff(n, t, ":", e);
        }
    }
    return ii(n, "name") || "";
}

class lo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class uo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class co {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class fo {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class ao {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const ho = t => new lo(t);

const po = t => new uo(t);

const $o = (t, n) => new co(t, n);

const yo = (t, n, e) => new fo(t, n, e);

const mo = (t, n, e, s = null, o = !1) => new ao(t, n, e, s, o);

const wo = () => {
    const t = rf();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, ps);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, ps, s);
    }
    let o = t.$.getHostProp(e, $s);
    o === null && (o = 0);
    t.$.setHostProp(e, $s, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const bo = t => {
    const n = Te(t) && !Uf(t) ? ce(void 0, t) : t;
    return $i(n);
};

const vo = t => _o(bo, t);

const _o = (t, ...n) => {
    const {val: e, set: s} = wo();
    if (e != null) {
        return e;
    }
    t = Te(t) && !Uf(t) ? lf(t, ...n) : t;
    return s(t);
};

const go = () => ({
    pending: $i(0),
    version: $i(0)
});

function R(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = q(t.container, n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.pending.value++;
    }
}

function P(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return t.getHostProp(n, rs);
}

function T(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    Ko(t, gs, null);
}

function q(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return function e(t) {
        if (!__EXPERIMENTAL__.suspense) {
            return null;
        }
        return Go(t, gs, null) || null;
    }(n) || P(t, n);
}

function M(t, n) {
    __EXPERIMENTAL__.suspense && Ko(t, gs, n);
}

function A(t, n, e) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    M(n, e);
    const s = n.dirtyChildren;
    if (!s || s.length === 0) {
        return;
    }
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        A(t, o, P(t, o) || e);
    }
}

const Eo = t => {
    if (t.Tn) {
        try {
            t.Tn();
        } catch (t) {
            ((t, ...n) => {
                be(!1, t, ...n);
            })(t);
        }
        t.Tn = null;
    }
};

function x(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    o || (o = of(e, s));
    const r = o.$;
    const i = o.m;
    nl(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r._ : null;
        const l = Go(i, ys, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = Go(i, ms, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return fe(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i));
}

function I(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = of(t, n);
    typeof this === "string" && kf(Rf(e.$, this));
    const s = Sf[0];
    return x(s, t, n, e);
}

function N(t) {
    return t.k === t.R ? t.T : null;
}

function C(t) {
    return t.q || N(t);
}

function O(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = N(t);
    return e === o ? null : e;
}

const So = Object.prototype.hasOwnProperty;

function j(t, n, e, s, o, r) {
    Ko(n, e, r);
    dn(t, mo(n.node, e, s, o, (n.flags & 512) !== 0));
}

function L(t, n, e, s) {
    return {
        $: t,
        M: n,
        N: e,
        O: s,
        j: [],
        L: [],
        X: [],
        k: null,
        q: null,
        D: null,
        T: null,
        R: null,
        W: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: 0,
        G: 0,
        K: !0,
        Z: !1,
        tt: {
            nt: new Ri({
                O: s,
                et: !0
            }),
            st: new Ri({
                O: s,
                et: !1
            })
        }
    };
}

function F(t, n, e, s, o) {
    const r = t ?? L(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.M = e;
        t.N = s;
        t.O = o;
        t.tt.nt.data.O = o;
        t.tt.st.data.O = o;
        t.L.length = 0;
        t.X.length = 0;
    })(r, n, e, s, o);
    return r;
}

const ko = (t, n, e, s, o, r, i) => X(F(i, t, n, o, r), e, s);

const Ro = (t, n, e, s, o, r, i, c, l = !1, u) => X(F(u, t, n, i, c), e, s, o, r, l);

function X(t, n, e, s = Rl(e), o = null, r = !1) {
    D(t, n, e, s, o, r);
    const i = G(t);
    if (Ps(i)) {
        return i.finally(() => {
            K(t);
        });
    }
    K(t);
}

function D(t, n, e, s = Rl(e), o = null, r = !1) {
    const i = t.Z;
    t.Z = r || i;
    t.k = e;
    t.D = null;
    t.q = s;
    t.T = o;
    t.R = e;
    B(t, n, !0);
    try {
        if (t.k.flags & 32) {
            return;
        }
        for (;t.j.length; ) {
            for (;t.Y < t.G; ) {
                if (typeof t.J === "string") {
                    mt(t, t.J);
                } else if (typeof t.J === "number") {
                    mt(t, t.J + "");
                } else if (t.J && typeof t.J === "object") {
                    if (qi(t.J)) {
                        const n = t.J.type;
                        if (typeof n === "string") {
                            nt(t);
                            ct(t, t.J, n);
                            const e = t.J.constProps && So.call(t.J.constProps, Ss) || So.call(t.J.varProps, Ss);
                            e ? t.D || Z(t, !1) : U(t, t.J.children, !0);
                        } else if (typeof n === "function") {
                            if (n === Ji) {
                                nt(t);
                                dt(t, "F", t.J.key);
                                U(t, t.J.children, !0);
                            } else if (n === Yi) {
                                nt(t);
                                Q(t) || U(t, t.J.children, !0);
                            } else if (n === vt) {
                                J(t);
                                U(t, t.J.children, !0, !1);
                            } else if (n === Zi) {
                                tt(t);
                            } else if (n === Ki) {
                                tt(t);
                            } else {
                                nt(t);
                                pt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.J)) {
                        U(t, t.J, !1);
                    } else if (iu(t.J)) {
                        dt(t, "S", null);
                        const n = t.J instanceof ki ? t.J.rt() : t.J;
                        const e = t.q?.[vr]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof ki && (s = Tt(e, n));
                        if (!s) {
                            const e = t.D || t.q;
                            U(t, W(t, () => ff(n, e, ".", t.$)), !0);
                        }
                    } else if (Ps(t.J)) {
                        dt(t, "A", null);
                        t.L.push(t.J, t.D || t.q);
                    }
                } else {
                    t.J === Gi || mt(t, "");
                }
                V(t);
            }
            tt(t);
            Y(t);
            z(t);
        }
    } finally {
        t.Z = i;
    }
}

function W(t, e) {
    try {
        return e();
    } catch (s) {
        if (Ps(s)) {
            const o = s.then(() => n(e));
            t.L.push(o, t.D || t.q);
            return null;
        }
        throw s;
    }
}

function V(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.Y++;
    if (t.Y < t.G) {
        t.J = t.H[t.Y];
    } else if (t.j.length > 0 && t.j[t.j.length - 1] === !1) {
        return z(t);
    }
    t.D !== null ? t.D = null : t.q = O(t, t.q);
}

function U(t, n, e, s = !0) {
    if (s && (n == null || e && Re(n) && n.length === 0)) {
        Z(t);
        return;
    }
    B(t, n, e);
    if (e) {
        const n = t.Z || !!t.D || !Rl(t.q);
        t.Z = n;
        t.B = null;
        t.W = null;
        t.U = null;
        t.k = t.D || t.q;
        t.q = Rl(t.k);
        t.D = null;
    }
    t.K = !1;
}

function z(t) {
    const n = t.j.pop();
    if (n) {
        t.Z = t.j.pop();
        t.B = t.j.pop();
        t.W = t.j.pop();
        t.U = t.j.pop();
        t.D = t.j.pop();
        t.q = t.j.pop();
        t.k = t.j.pop();
    }
    t.J = t.j.pop();
    t.G = t.j.pop();
    t.Y = t.j.pop();
    t.H = t.j.pop();
    V(t);
}

function B(t, n, e) {
    t.j.push(t.H, t.Y, t.G, t.J);
    e && t.j.push(t.k, t.q, t.D, t.U, t.W, t.B, t.Z);
    t.j.push(e);
    if (Array.isArray(n)) {
        t.Y = 0;
        t.G = n.length;
        t.H = n;
        t.J = t.G > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.Y = 0;
        t.J = null;
        t.H = null;
        t.G = 0;
    } else {
        t.Y = 0;
        t.J = n;
        t.H = null;
        t.G = 1;
    }
}

function H(t) {
    if (t.D) {
        return C(t);
    }
    return O(t, t.q) || N(t);
}

function J(t) {
    const n = t.J;
    const e = n.key;
    t.q = Go(t.k, e, n => il(t.$.rootVNode, n));
    t.q = t.q && t.q.flags & 32 ? null : t.q;
    if (t.q == null) {
        t.D = Vo();
        Ko(t.D, De, e);
        t.D.slotParent = t.k;
        Ko(t.k, e, t.D);
    }
}

function Q(t) {
    const n = t.J;
    const e = Zl(t.k);
    const s = k(e, n, t.$);
    const o = ii(n, rs) || null;
    const r = e ? Go(e, s, null) : null;
    if (r == null) {
        t.D = Vo();
        Ko(t.D, De, s);
        Ko(t.D, rs, o);
        A(t.$, t.D, o);
        e && Ko(e, s, t.D);
        wl(t.M, t.k, t.D, H(t));
        return !1;
    }
    if (r === t.q) {} else {
        const n = r.parent;
        t.D = r;
        Ko(t.D, De, s);
        Ko(t.D, rs, o);
        A(t.$, t.D, o);
        e && Ko(e, s, t.D);
        ml(t.M, t.D);
        wl(t.M, t.k, t.D, H(t));
        n && zo(n) && !n.firstChild && El(n) === is && _l(t.M, n.parent, n, !0);
    }
    return !0;
}

function Y(t) {
    const n = t.B;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            Et(t.$, t.M, e, t.N);
            _l(t.M, t.k, e, !0);
        }
        n.clear();
        t.B = null;
    }
    t.q = null;
}

function G(t) {
    for (;t.L.length; ) {
        const n = t.L.shift();
        const e = t.L.shift();
        if (Ps(n)) {
            return n.then(n => {
                D(t, n, e);
                return G(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return G(t);
            });
        }
        D(t, n, e);
    }
    if (t.X.length) {
        const n = t.X.splice(0);
        return Promise.all(n).then(() => G(t));
    }
}

function K(t) {
    t.M = null;
    t.N = null;
}

function Z(t, n = !0) {
    const e = t.q && Rl(t.q);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            Et(t.$, t.M, s, t.N);
            s = s.nextSibling;
        }
        gl(t.M, t.q, e, n);
    }
}

function tt(t) {
    const n = N(t);
    if (t.q !== null && t.q !== n) {
        for (;t.q && t.q !== n; ) {
            const n = t.q;
            t.q = O(t, t.q);
            if (t.k === n.parent) {
                Et(t.$, t.M, n, t.N);
                _l(t.M, t.k, n, !0);
            }
        }
    }
}

function nt(t) {
    if (t.q !== null && Jo(t.q)) {
        const n = t.q;
        t.q = O(t, t.q);
        _l(t.M, t.k, n, !0);
    }
}

function et(t, n, e) {
    if (iu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw qe(15, [ e ]);
}

function st(t, e, s, o, r) {
    return n(() => ff(o, e, s, t, r));
}

function rt(t, n, e, o, r) {
    const i = t.O;
    const c = o.then(t => E(n, e, s(e, t, i), r));
    t.X.push(c);
}

function it(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(es, "html");
    }
}

function ot(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function lt(t, n, e, r) {
    const i = function c(t, n) {
        const e = vl(t.k, !0);
        const s = o(e, n);
        const r = document;
        const i = s.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(s.elementNamespace, n);
        t.D = Xo(i, n);
        t.D.flags |= s.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.D;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (Is(n)) {
                ut(n, o, i, l, t);
                continue;
            }
            if (n === "ref" && et(o, i, r)) {
                continue;
            }
            iu(o) && (o = st(t.$, t.D, n, o, t.tt.nt));
            if (Ps(o)) {
                rt(t, i, n, o, u);
                continue;
            }
            if (n === Ss) {
                it(i, o);
                continue;
            }
            if (e === "textarea" && n === "value" && ot(i, o)) {
                continue;
            }
            E(i, n, s(n, o, t.O), u);
        }
    }
    const a = n.key;
    a && (t.D.key = a);
    if (t.O) {
        const e = So.call(n.varProps, "class") || n.constProps && So.call(n.constProps, "class");
        e || i.setAttribute("class", t.O);
    }
    hl(t.M, t.k, t.D, C(t));
}

function ut(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(x.bind(null, n));
                }
            } else {
                e && s.push(x.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = x.bind(null, n));
    }
    t.charAt(2) !== "e" && Zo(o.M, s, t, "");
    (function i(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, r);
}

function ct(t, n, e) {
    if (t.Z) {
        lt(t, n, e, null);
    } else {
        const s = t.q && zo(t.q);
        const o = s && e === El(t.q);
        const r = n.key;
        const i = s && t.q.key;
        if (o && r === i) {
            at(t, e, r);
        } else {
            const s = ft(e, r);
            ht(t, e, r, s, t.k) && lt(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.D || t.q;
    s && function r(t, n, e, s) {
        t.Z || nl(t.$, n);
        const o = n.props;
        for (const r in e) {
            const i = e[r];
            if (o && So.call(o, r)) {
                const e = o[r];
                if (i !== e) {
                    if (i instanceof ki && e instanceof ki && Pt(i, e)) {
                        continue;
                    }
                    Po(t, n, r, i, s);
                }
            } else {
                i != null && Po(t, n, r, i, s);
            }
        }
        if (o) {
            for (const r in o) {
                So.call(e, r) || r.charAt(0) === ":" || Is(r) || Po(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const Po = (t, n, e, s, o) => {
    if (Is(e)) {
        ut(e, s, n.node, n, t);
        return;
    }
    if (e === ys || e === ms) {
        Ko(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (et(s, t, o)) {
            return;
        }
    }
    const i = n[vr]?.get(e);
    if (iu(s)) {
        const o = s instanceof ki ? s.rt() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && gn(t.$, i);
        const r = n;
        s = st(t.$, r, e, o, t.tt.st);
    } else {
        i && gn(t.$, i);
    }
    if (Ps(s)) {
        const o = n;
        const i = s.then(n => {
            j(t.M, o, e, n, t.O, r);
        });
        t.X.push(i);
        return;
    }
    j(t.M, n, e, s, t.O, r);
};

function ft(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function at(t, n, e) {
    const s = ft(n, e);
    if (s && t.B?.has(s)) {
        t.B.delete(s);
        return !0;
    }
    return !1;
}

function ht(t, n, e, s, o, r) {
    t.D = function i(t, n, e) {
        let s = null;
        if (t.W === null) {
            const o = t.q;
            if (o) {
                const s = zo(o) ? El(o) : null;
                const r = wt(o) || bt(o, t.$._);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.W = new Map;
            t.U = [];
            const r = N(t);
            let i = t.q;
            for (;i && i !== r; ) {
                const o = zo(i) ? El(i) : null;
                const r = wt(i) || bt(i, t.$._);
                s === null && r == e && o == n ? s = i : r === null ? t.U.push(o, i) : t.W.set(ft(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.U.length; e += 2) {
                if (t.U[e] === n) {
                    s = t.U[e + 1];
                    t.U.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ft(n, e);
            const r = t.W.get(o);
            if (r) {
                s = r;
                t.W.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.q) {
                    const n = zo(t.q) ? El(t.q) : null;
                    const e = wt(t.q) || bt(t.q, t.$._);
                    if (e != null) {
                        const s = ft(n, e);
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                        t.W?.delete(s);
                    }
                }
                return;
            }
            const e = N(t);
            let s = t.q;
            for (;s && s !== n && s !== e; ) {
                const n = zo(s) ? El(s) : null;
                const e = wt(s) || bt(s, t.$._);
                if (e != null) {
                    const o = ft(n, e);
                    t.B ||= new Map;
                    t.B.set(o, s);
                    t.W?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.D) {
        s || wl(t.M, o, t.D, C(t));
        t.q = t.D;
        t.D = null;
        return !1;
    }
    if (s != null) {
        const n = t.B?.get(s) || null;
        if (n) {
            t.B.delete(s);
            if (r && t.q) {
                const n = wt(t.q) || bt(t.q, t.$._);
                if (n != null) {
                    const e = zo(t.q) ? El(t.q) : null;
                    const s = ft(e, n);
                    if (s != null) {
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                    }
                }
            }
            n !== t.q && wl(t.M, o, n, C(t));
            t.q = n;
            t.D = null;
            return !1;
        }
    }
    return !0;
}

function dt(t, n, e) {
    const s = n === "F";
    const o = wt(t.q);
    const r = t.q && Qo(t.q);
    const i = r && o === e && (!s || !!e);
    if (i) {
        at(t, null, o);
        return;
    }
    if (e === null || t.Z) {
        dl(t.M, t.k, t.D = Vo(), H(t));
        t.D.key = e;
        return;
    }
    if (ht(t, null, e, ft(null, e), t.k, !0)) {
        dl(t.M, t.k, t.D = Vo(), H(t));
        t.D.key = e;
    }
}

function pt(t, n) {
    const e = n[Vf];
    let s = t.D || t.q;
    const o = t.J;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.it;
        const l = bt(s, t.$._);
        const u = o.key || c;
        const f = wt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                at(t, null, u);
            } else {
                $t(t, s, i, n);
                s = t.D;
                r = !0;
            }
        } else {
            if (ht(t, null, u, u, t.k)) {
                $t(t, s, i, n);
                r = !0;
            }
            s = t.D || t.q;
        }
        if (s) {
            const e = Go(s, ds, t.$._);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = _t(n[Jr], e[Jr], e[Gr], s, !1);
                        o ||= t;
                        const r = _t(n[Qr], e[Qr], e[Gr], s, !0);
                        o ||= r;
                        e[Yr] = n[Yr];
                    } else if (n) {
                        Ko(t, ds, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    $t(t, s, i, n);
                    s = t.D;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                Ko(s, Le, i);
                s.flags &= -33;
                hn(t.$, s, 4, t.N);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new Pi(vt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            _e(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (qi(n) && ii(n, De) || "") + "";
                const i = ve(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            U(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = wt(s);
        const i = e === r;
        const c = bt(s, t.$._);
        const l = c == null;
        if (s && !l || !s) {
            yt(t);
            s = t.D;
        } else if (i) {
            at(t, null, e);
        } else {
            ht(t, null, e, e, t.k) && yt(t);
            s = t.D || t.q;
        }
        if (s) {
            let e = s;
            for (;e && (!Qo(e) || Go(e, Le, null) === null); ) {
                e = e.parent || Zl(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[jr] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            hn(t.$, s, 8, t.N);
        }
    }
}

function $t(t, n, e, s) {
    n && _n(t.$, n);
    dl(t.M, t.k, t.D = Vo(), H(t));
    const o = t.J;
    Ko(t.D, Le, e);
    Ko(t.D, ds, s);
    t.D.key = o.key;
}

function yt(t) {
    dl(t.M, t.k, t.D = Vo(), H(t));
    const n = t.J;
    Ko(t.D, ds, n.props);
    n.key && (t.D.key = n.key);
}

function mt(t, n) {
    if (t.q !== null) {
        const e = Gl(t.q);
        if (e === 3) {
            if (n !== Sl(t.q)) {
                kl(t.M, t.q, n);
                return;
            }
            return;
        }
    }
    hl(t.M, t.k, t.D = Wo(document.createTextNode(n), n), C(t));
}

function wt(t) {
    if (t == null || Jo(t)) {
        return null;
    }
    return t.key;
}

function bt(t, n) {
    if (t == null || Jo(t)) {
        return null;
    }
    const e = Go(t, Le, n);
    return e ? e.it : null;
}

function vt() {}

function _t(t, n, e, s, o = !0) {
    if (gt(t) && gt(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === Qe) {
                continue;
            }
            if (!n || t[s] !== n[s]) {
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = t[s]);
                    const o = ri(e, s);
                    o || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === Qe) {
                continue;
            }
            if ((!t || !So.call(t, s)) && o) {
                delete n[s];
                const t = ri(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function gt(t) {
    if (!t) {
        return !0;
    }
    return hr(t);
}

function Et(t, n, e, s = null) {
    let o = e;
    const r = s && cn(s) ? y(s) : null;
    if (Jo(e)) {
        Rt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && cn(o) && a(t, r, o);
        const c = o.flags;
        if (c & 3) {
            _n(t, o);
            Rt(o);
            const r = c & 2 && Go(o, Le, null) !== null;
            if (r) {
                const e = t.getHostProp(o, ps);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (ke(r)) {
                            const n = su(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                hn(t, o, 128, s);
                                continue;
                            }
                            (r instanceof Ur || vu(r)) && _n(t, r);
                            (n || r instanceof Hr) && Eo(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (S(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? il(t.rootVNode, e) : e;
                                let c = Rl(o);
                                for (;c; ) {
                                    Et(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                kt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = Yo(o);
            if (i) {
                if (o === e) {
                    const n = Rl(o);
                    if (n) {
                        yn(n);
                        return;
                    }
                    St(t, o);
                }
            } else {
                const t = Rl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Rt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function St(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, De);
    e != null && t.getHostProp(n.slotParent, e) === n && Ko(n.slotParent, e, null);
}

function kt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && El(s) === is) {
            St(t, e);
            _l(n, s, e, !0);
        }
    }
}

function Rt(t) {
    t.flags |= 32;
}

function Pt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ot === t.ot && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.lt, t.lt);
}

function Tt(t, n) {
    if (!(n instanceof ki)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof ki && Pt(s, n)) {
            return !0;
        }
    }
    return !1;
}

const To = (t, n, e, s, o) => {
    const r = ae(t.jt, n, t);
    if (e) {
        r.Ft = m(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, Le));
    if (Ae(s)) {
        o = o || t.getHostProp(n, ds) || ni;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (Uf(s)) {
        const t = s;
        i = () => fe(r, t, [ o || ni, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => fe(r, t, [ o || ni ]);
    }
    const l = $e;
    const u = (e = 0) => Ts(() => {
        if (!c) {
            t.setHostProp(n, $s, null);
            t.setHostProp(n, vs, null);
        }
        e > 0 && Uo(n) && _n(t, n);
        return qs(i(o), t => qs(r.Xt, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < Rs) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, bs);
        if (o) {
            return function r(t, n, e) {
                const s = xt(n);
                let o = n;
                const r = "q-e:qvisible";
                return qs(s, n => {
                    const s = !n;
                    let i = null;
                    for (const c in e) {
                        if (Object.prototype.hasOwnProperty.call(e, c)) {
                            let l = n;
                            let u = c;
                            if (s) {
                                if (c !== r && !c.startsWith("q-d:") && !c.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!i) {
                                    i = Nt();
                                    const n = $e;
                                    n && t.ut(i) || (o = It(o, i));
                                }
                                l = i;
                            }
                            if (l) {
                                l.type === "script" && c === r && (u = "q-d:qinit");
                                Mt(l, u, e[c]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (Ps(t) && e < Rs) {
            return t.then(() => u(++e));
        }
        if (e >= Rs) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Mt(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = Os(n);
    c && At(t, f, "capture");
    l && At(t, f, "preventdefault");
    u && At(t, f, "stoppropagation");
}

function At(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === ni && (t.varProps = {});
    t.varProps[s] = !0;
}

function xt(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (qi(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (Re(t)) {
            n.push(...t);
        } else {
            if (Ps(t)) {
                return qs(t, t => xt(t));
            }
            if (iu(t)) {
                return xt(t.untrackedValue);
            }
        }
    }
    return null;
}

function It(t, n) {
    if (qi(t)) {
        if (t.type !== Ji && !Uf(t.type)) {
            return Fi(Ji, null, null, [ t, n ], 0, null);
        }
        t.children == null ? t.children = n : Re(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return t;
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        return Fi(Ji, null, null, [ t, n ], 0, null);
    }
    if (Re(t) && t.length > 0) {
        It(t[0], n);
        return t;
    }
    return t;
}

function Nt() {
    return new Pi("script", null, {
        hidden: ""
    }, null, 0, null);
}

function Ct(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Ot(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Ct(t[c], c, r, s);
    }
    return i;
}

function jt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Lt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = Rl(e);
    const f = L(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return Ro(c, n, Ot(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        gl(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return Ro(c, n, Ot(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        gl(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const m = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== m; ) {
            const s = t.nextSibling;
            _l(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = m;
        return Ro(c, n, Ot(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const w = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const _ = function v(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < _.length; t++) {
        const s = _[t];
        const o = s.key;
        if (b.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            _l(n, e, s, !0);
        }
    }
    const S = new Int32Array(w);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < w; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(w);
    const T = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < T.length; t++) {
        P[R[T[t]]] = 1;
    }
    let M = d;
    let A = m;
    const I = () => {
        for (;M >= h; ) {
            const t = M - h;
            if (P[t] === 1) {
                A = g[S[t]];
                M--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = g[r];
                const s = A === null ? e.lastChild === t : t.nextSibling === A;
                s || wl(n, e, t, A);
                A = t;
                M--;
                continue;
            }
            let l = M;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = M - l + 1;
            const d = Ro(c, n, Ot(o, a, null, i, l, M), e, A, A, s, null, !0, f);
            return qs(d, () => {
                const t = jt(e, A, u);
                A = t;
                M = l - 1;
                return I();
            });
        }
    };
    return I();
}

function Ft(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, ps);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof eu) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = nu(s, n, t);
                Ps(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Xt(t, n) {
    const e = t.props ||= {};
    e[Nr] = n;
}

function Dt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[Cr] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[Cr] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = fl(n, document, r, e);
    const u = zo(r) && i || r;
    const f = u === r ? null : c;
    hl(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Wt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[Nr];
    }(t);
    if (!r) {
        return;
    }
    Xt(t, null);
    iu(r) && (r = r.value);
    return ko(n, e, r, o, s, null);
}

function Vt(t, n, e, s) {
    t.dirty &= -5;
    const o = t;
    const r = n.getHostProp(o, Le);
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, ds) || null;
    return zt(n, o, o, r, i, e, s);
}

function Ut(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[jr] || null;
        e && delete n[jr];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return zt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function zt(t, e, s, o, r, i, c) {
    const l = Ts(() => To(t, e, s, o, r), s => {
        const o = t.getHostProp(e, He);
        return n(() => ko(t, i, s, e, c, xs(o)));
    }, n => {
        t.handleError(n, e);
    });
    if (Ps(l)) {
        return l;
    }
    return;
}

function Bt(t, n, e, s, o, r = null) {
    n.push(mo(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Ht(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[Ir] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        iu(e) && (e = e.value);
        const r = s.isConst;
        Bt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[Ir];
    })(t);
}

function Jt(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, ps);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof eu && n.h & 16) {
            n.h &= -17;
            const t = n;
            Eo(t);
        }
    }
}

function Qt(t, e) {
    t.dirty &= -33;
    const s = e.getHostProp(t, Or);
    if (!s) {
        return;
    }
    const o = s.ct;
    const r = he();
    r.$ = e;
    return qs(n(() => ce.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return fu(e, s, o);
        }
    });
}

function Yt(t, n, e, s) {
    t.dirty &= -257;
    const o = t;
    const r = n.getHostProp(o, ds) || null;
    if (!r) {
        return;
    }
    let i = oi(r, "items");
    iu(i) && (i = lf(i));
    const c = oi(r, "key$");
    const l = oi(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Lt(n, e, o, s, i, u, f);
    }
    return qs(c.resolve(), t => qs(l.resolve(), r => Lt(n, e, o, s, i, t, r)));
}

let qo = null;

const Mo = (t, n, e) => {
    qo || (qo = t.insertBefore);
    qo.call(t, n, e);
};

function Gt(t) {
    let n = null;
    let e = null;
    let o = null;
    const r = new Set;
    const i = () => {
        if (o) {
            if (o.length === 1) {
                Mo(n, o[0], e);
            } else {
                const t = n.ownerDocument || n;
                const s = t.createDocumentFragment();
                for (let t = 0; t < o.length; t++) {
                    s.appendChild(o[t]);
                }
                Mo(n, s, e);
            }
            o = null;
            n = null;
            e = null;
            r.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof fo) {
            if (n === l.parent && e === l.beforeTarget) {
                o || (o = []);
                o.push(l.target);
                r.add(l.target);
                continue;
            }
            if (!o) {
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            if (n === l.parent) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            if (r.has(l.target) || e && l.target === e || n && l.target === n) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                o = [ l.target ];
                r.add(l.target);
                continue;
            }
            Mo(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof lo) {
            (r.has(l.target) || e && l.target === e || n && l.target === n) && i();
            l.target.remove();
            continue;
        }
        if (l instanceof uo) {
            (r.has(l.target) || e && l.target === e || n && l.target === n) && i();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof co) {
            l.target.nodeValue = l.text;
        } else if (l instanceof ao) {
            const t = l.target;
            const e = l.attrName;
            const o = l.attrValue;
            const r = o != null ? s(e, o, l.scopedStyleIdPrefix) : null;
            const c = r == null || r === !1;
            if (Ao(t, e)) {
                t[e] = xo(r);
            } else if (e === Ss) {
                n === t && i();
                t.innerHTML = r;
                t.setAttribute(es, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = r : E(t, e, r, l.isSvg);
            }
        }
    }
    i();
}

const Ao = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const xo = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const Io = (t => () => queueMicrotask(t))(tn);

const Co = Ws(tn);

let Oo = !1;

function Kt() {
    if (!Oo) {
        Oo = !0;
        Io();
    }
}

function Zt() {
    if (!Oo) {
        Oo = !0;
        Co();
    }
}

function tn() {
    Oo = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (nn(e, n)) {
            Zt();
            return;
        }
    }
}

function nn(t, n) {
    const e = $e;
    const s = y(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        en(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 1023)) {
            __EXPERIMENTAL__.suspense && T(l);
            p(r, s, on(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 128) {
                Jt(l, r);
            } else if (l.dirty & 64) {
                const n = rn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -1024;
            p(r, s, on(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Ft(l, r, s);
            } else if (l.dirty & 2) {
                e = Wt(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Vt(l, r, i, t);
            } else if (l.dirty & 8) {
                e = Ut(l, r, i, t);
            } else if (l.dirty & 256) {
                e = Yt(l, r, i, t);
            } else if (l.dirty & 16) {
                Ht(l, i);
            } else if (l.dirty & 32) {
                e = Qt(l, r);
            } else if (l.dirty & 64) {
                const n = rn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 512 && Dt(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && Ps(e)) {
            R(s, l);
            const n = e;
            s.promise = n;
            c(t, r);
            const o = l;
            n.catch(t => {
                s.promise === n && r.handleError(t, o);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                f(t, r);
                Kt();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    en(r, t, s, e);
}

function en(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        h(n, t);
        s || function o(t, n) {
            const e = y(t);
            const s = e.journal;
            if (s && s.length > 0) {
                Gt(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    nu(s, t, s.ft);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.pending.value = Math.max(0, e.pending.value - 1);
                e.version.value++;
            }
        })(e);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                sn(t);
            });
            return;
        }
        sn(t);
    }
}

function sn(t) {
    t.ht();
}

function rn(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        T(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = on(o[0], s, t);
    p(t, n, i);
    return i;
}

function on(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && ln(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && T(s);
    return on(s, n, e);
}

function ln(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    if (!n.props || !(rs in n.props) || !t.getHostProp(n, rs)) {
        return !1;
    }
    cn(n) || un(t, n, 0);
    return !0;
}

function un(t, n, e) {
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        xr.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    l(t, r);
    Kt();
    return r;
}

function cn(t) {
    return (t.flags & 256) !== 0;
}

function fn(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 16 && function e(t, n) {
            n.dirty &= -17;
            const e = n.getProp(Ir);
            if (!e || e.size === 0) {
                return;
            }
            for (const [o, r] of e.entries()) {
                let e = r.value;
                iu(e) && (e = e.value);
                const i = s(o, e, r.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, o, i);
            }
        }(t, n);
        n.dirty & 32 && Qt(n, t);
        n.dirty &= -1024;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(ps);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof eu) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = nu(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        Ps(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            const e = n;
            const s = t.getHostProp(e, ds) || null;
            if (!s) {
                return;
            }
            let o = oi(s, "items");
            iu(o) && (o = lf(o));
            const r = await oi(s, "key$").resolve();
            const i = await oi(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const jo = [];

function an(t) {
    for (let n = 0; n < jo.length; n++) {
        const e = jo[n];
        const s = jo[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function hn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return $e;
    }()) {
        const e = fn(t, n);
        Ps(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function e(t, n, s) {
            jo.push(n);
            let o = P(t, n);
            let r = n.slotParent || n.parent;
            for (;r; ) {
                const e = r.dirty & 1023;
                const i = cn(r);
                __EXPERIMENTAL__.suspense && (o ||= P(t, r) || (e ? q(t, r) : null));
                if (r === s || e) {
                    M(n, o);
                    an(r);
                    if (i) {
                        const t = y(r);
                        t.position !== r && (t.position = n);
                    }
                    jo.length = 0;
                    return;
                }
                if (i) {
                    const t = y(r);
                    t.position !== r && (t.position = n);
                }
                jo.push(r);
                r = r.slotParent || r.parent;
            }
            jo.length = 0;
            ((t, ...n) => {
                const e = be(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(t, n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        M(n, P(t, n) || q(t, c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (cn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = y(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        cn(n) ? M(n, P(t, n)) : function l(t, n) {
            jo.push(n);
            let e = __EXPERIMENTAL__.suspense ? P(t, n) : null;
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const o = cn(s);
                __EXPERIMENTAL__.suspense && (e ||= P(t, s) || (o ? q(t, s) : null));
                if (o) {
                    M(n, e);
                    an(s);
                    jo.length = 0;
                    return !0;
                }
                jo.push(s);
                s = s.slotParent || s.parent;
            }
            M(n, e);
            jo.length = 0;
            return !1;
        }(t, n) || un(t, n, 0);
    }
}

function dn(t, n) {
    t.push(n);
}

const Lo = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const Fo = t => {
    let n = null;
    return e => {
        n || (n = Lo(e, t));
        return n.call(e);
    };
};

const Xo = (t, n, e = null) => {
    const s = new Tr(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const Do = t => {
    const n = new Tr(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const Wo = (t, n) => {
    const e = new qr(-4084, null, null, null, null, t, n);
    return e;
};

const Vo = () => {
    const t = new Pr(null, -4094, null, null, null, null, null, null);
    return t;
};

const Uo = t => t instanceof Rr;

const zo = t => (t.flags & 1) === 1;

const Bo = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const Ho = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const Jo = t => (t.flags & 4) === 4;

const Qo = t => (t.flags & 2) === 2;

const Yo = t => {
    const n = t.flags;
    return (n & 2) === 2 && Go(t, De, null) !== null;
};

const Ah = t => t;

const Go = (t, n, e) => {
    if (zo(t) || Qo(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const Ko = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const Zo = (t, n, e, s, o = null) => {
    if (zo(n)) {
        Ko(n, e, s);
        dn(t, mo(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const tl = t => {
    if (t.key) {
        return;
    }
    const n = Al(t.node, Es);
    n && (t.key = n);
};

const nl = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (Is(c)) {
                pn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== Es && c) {
                if (c.startsWith(es)) {
                    const t = i.value;
                    t === "html" ? Ko(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && Ko(e, "value", s.value);
                } else {
                    const t = i.value;
                    Ko(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        Go(e, ys, null) === null && Go(e, ms, null) === null || (n.flags |= 64);
    }
};

const el = t => {
    if (t.vt === "_run") {
        const n = t.getCaptured()?.[0];
        if (Ae(n)) {
            return n;
        }
    }
    return t;
};

function pn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = el(Nn(i[t], e));
        c.push(x.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function $n(t, n, e) {
    let s = Rl(n);
    for (;s; ) {
        if (Jo(s)) {
            rl(t, s);
            e(s, n);
        } else {
            zo(s) ? e(s, n) : $n(t, s, e);
        }
        s = s.nextSibling;
    }
}

function yn(t) {
    let n = t;
    if (Jo(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = Rl(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const sl = (t, n, e) => {
    let s = t;
    for (;e && s && Qo(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !Qo(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !Qo(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (Jo(t) && e && zo(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && Hl(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const rl = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = bl(n, !0);
        const o = e.node;
        const r = Dl(s);
        let i = sl(n, !1, !0);
        const c = sl(n, !0, !0);
        const l = o || (c && zo(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && Jo(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                dn(t, yo(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = sl(i, !1, !0);
        }
        i = n;
        for (;i && Jo(i); ) {
            const n = sl(i, !0, !0);
            const e = !n || !Jo(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    dn(t, $o(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    dn(t, yo(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const il = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const s = t.vNode;
        if (s) {
            return s;
        }
        if (__EXPERIMENTAL__.suspense && t._qSegment) {
            e = Do(i);
            tl(e);
            t.vNode = e;
            return e;
        }
    }
    if (Uo(i)) {
        e = i;
    } else {
        if (__EXPERIMENTAL__.suspense && i._qSegment) {
            e = i.vNode || Do(i);
            tl(e);
        } else {
            let t = i;
            const n = [ i ];
            for (;t && t !== s && !t.vNode; ) {
                t = t.parentElement;
                n.push(t);
            }
            t.vNode && (e = t.vNode);
            for (let t = n.length - 2; t >= 0; t--) {
                e = ul(e, n[t]);
            }
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = cl(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = ol(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const ol = (t, n) => {
    let e = Rl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const ll = [];

const ul = (t, n) => {
    let e = Rl(t);
    for (;e && (!(e instanceof Tr) || e.node !== n); ) {
        if (Qo(e)) {
            const t = e.nextSibling;
            const n = Rl(e);
            if (n) {
                t && ll.push(t);
                e = n;
            } else {
                e = t || (ll.length ? ll.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || ll.pop();
        }
    }
    for (;ll.length; ) {
        ll.pop();
    }
    return e;
};

const cl = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const fl = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = Xo(o, "errored-host");
    if (Bo(e)) {
        wl(t, r, e, null);
    } else {
        const n = [];
        $n(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            wl(t, r, n[e], null);
        }
    }
    return r;
};

const al = Gt;

const hl = (t, n, e, s) => {
    const o = zo(n);
    o && Pl(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    yl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : bl(n, !1);
    l && !c && dn(t, yo(i, l, pl(t, n, s)?.node ?? null));
    $l(n, e, s);
    c && (e.flags |= 32);
};

const dl = (t, n, e, s) => {
    const r = zo(n);
    r && Pl(n);
    const c = e.parent;
    if (e === s) {
        if (c) {
            return;
        }
        s = null;
    }
    yl(t, c, n, e);
    const l = n.flags & 32;
    const u = !r && n.flags & 2048 ? n.props?.[Fe] : null;
    const f = u ? null : r ? n : vl(n, !1);
    const a = u || f?.node;
    const h = pl(t, n, s);
    const d = h?.node ?? null;
    const p = Yo(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const r = vl(n, !1);
        const c = pl(t, n, s)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(r, e);
        $n(t, e, n => {
            if (Jo(n)) {
                dn(t, yo(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, s, r) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (zo(c)) {
                                e = c.node;
                                const t = El(c);
                                const l = c.parent;
                                const h = u == null ? n : l && vl(l, !0);
                                if (h) {
                                    const t = o(h, El(c));
                                    s = t.elementNamespace;
                                    r = t.elementNamespaceFlag;
                                }
                                const d = Rl(c);
                                a = i(e, t, s, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= r;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (ql(e)) {
                                    const t = re(e);
                                    if (t) {
                                        const n = Rl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, r, l, u);
                    t && (n.node = t);
                }
                dn(t, yo(n.node, a, c));
            }
        });
    } else {
        a && !l && $n(t, e, n => {
            dn(t, yo(n.node, a, d));
        });
    }
    $l(n, e, s);
    l && (e.flags |= 32);
};

const pl = (t, n, e) => {
    let s = null;
    e == null ? Qo(n) && (s = sl(n, !0, !1)) : s = Qo(e) ? sl(e, !0, !0) : e;
    s && Jo(s) && rl(t, s);
    return s;
};

const $l = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const yl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && _l(t, n, s, !1);
};

const ml = (t, n) => {
    let e = n;
    for (;e && Qo(e); ) {
        e = e.lastChild;
    }
    e && Jo(e) && (e.flags & 8) === 0 && rl(t, e);
};

const wl = (t, n, e, s) => {
    Bo(e) ? hl(t, n, e, s) : dl(t, n, e, s);
};

const bl = (t, n) => {
    for (;t && !zo(t); ) {
        if (t.flags & 2048) {
            return t.props?.[Fe];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const vl = (t, n) => {
    for (;t && !zo(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const _l = (t, n, e, s) => {
    Jo(e) && rl(t, e);
    if (s) {
        const s = Go(n, Ss, null) !== null;
        if (s) {
            return;
        }
        Bo(e) ? dn(t, ho(e.node)) : $n(t, e, n => {
            dn(t, ho(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const gl = (t, n, e, s = !0) => {
    const o = bl(n, !0);
    if (o && s) {
        if (Bo(n)) {
            dn(t, po(n.node));
        } else {
            const e = vl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? dn(t, po(o)) : $n(t, n, n => {
                dn(t, ho(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const El = t => {
    const n = Ah(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = Xl(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = Fl(t);
            switch (n) {
              case us:
                return 512;

              case cs:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const Sl = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const kl = (t, n, e) => {
    rl(t, n);
    n.text = e;
    dn(t, $o(n.node, e));
};

const Rl = t => {
    if (Jo(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.suspense && n === void 0 && zo(t) && function e(t) {
        const n = t.getAttribute(Rh);
        if (n === null) {
            return !1;
        }
        const e = Ll(t);
        return Kl(e) && e.localName === "template" && e.getAttribute(kh) === n && Cl(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = Pl(t));
    return n;
};

const Pl = n => {
    const e = Ah(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && ql(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = Ll(e);
            const o = Dl(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                tl(n);
                __EXPERIMENTAL__.suspense && e._qSegment;
                if (o) {
                    if (o.charCodeAt(0) === Oe && o.charCodeAt(1) === Oe) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = Wl(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = Kl(t);
                            return !n || n && vn(t);
                        };
                        let p = null;
                        Vl(e, ($, y, m, w, b) => {
                            if (Jl($())) {
                                for (;d(o); ) {
                                    o = Cl(o);
                                    if (!o) {
                                        throw qe(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;Jl($()); ) {
                                    t *= 10;
                                    t += m() - 48;
                                }
                                for (;t--; ) {
                                    const n = Do(o);
                                    tl(n);
                                    u(n);
                                    o = Cl(o);
                                    for (;Kl(o) && vn(o); ) {
                                        o = Cl(o);
                                        if (!o && t > 0) {
                                            throw qe(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                Ko(n, He, y());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                Ko(n, Le, y());
                            } else if ($() === 61) {
                                h || (h = se(s));
                                const t = y();
                                h.xn(parseInt(t, 10), n);
                            } else if ($() === 62) {
                                Ko(n, ds, y());
                            } else if ($() === 64) {
                                const e = w(b + 1) === Oe;
                                let s;
                                if (e) {
                                    m();
                                    s = decodeURIComponent(t(y()));
                                    m();
                                } else {
                                    s = y();
                                }
                                n.key = s;
                            } else if ($() === 91) {
                                Ko(n, ps, y());
                            } else if ($() === 94) {
                                Ko(n, $s, y());
                            } else if ($() === 96) {
                                h || (h = se(s));
                                wn(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = se(s));
                                n.slotParent = il(h.rootVNode, y());
                            } else if ($() === 93) {
                                Ko(n, Je, y());
                            } else if ($() === 123) {
                                m();
                                u(Vo());
                                Yl.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === Oe) {
                                const e = y();
                                const s = t(e);
                                const o = b + e.length + 1;
                                const r = w(o + 1) === Oe;
                                let i;
                                if (r) {
                                    m();
                                    i = decodeURI(t(y()));
                                    m();
                                } else {
                                    i = t(y());
                                }
                                Ko(n, s, i);
                            } else if ($() === 125) {
                                m();
                                n.lastChild = c;
                                r = Yl.pop();
                                l = Yl.pop();
                                c = Yl.pop();
                                i = Yl.pop();
                                n = Yl.pop();
                            } else if ($() === 126) {
                                const e = t(y());
                                Ko(n, De, e);
                            } else {
                                for (;Kl(o) && vn(o); ) {
                                    o = Cl(o);
                                }
                                const t = o && xl(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;Ql($()); ) {
                                    n += m() - 97;
                                    n *= 26;
                                }
                                n += m() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new qr(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = se(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return Wl(n, s, void 0);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let Tl = null;

const ql = t => {
    Tl || (Tl = t.hasAttribute);
    return Tl.call(t, es);
};

let Ml = null;

const Al = (t, n) => {
    Ml || (Ml = t.getAttribute);
    return Ml.call(t, n);
};

const xl = Fo("nodeType");

const Il = t => {
    const n = xl(t);
    return n === 3 || n === 1;
};

let Nl = null;

const Cl = t => {
    Nl || (Nl = Lo(t, "nextSibling"));
    jl || (jl = Lo(t, "firstChild"));
    for (;t; ) {
        t = Nl.call(t);
        if (t !== null) {
            const n = xl(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(ts)) {
                    return mn(t, Ke, Nl, jl);
                }
                if (t.nodeValue?.startsWith(Ze)) {
                    return mn(t, [ Ke, ns ], Nl, jl);
                }
                if (n?.startsWith(es)) {
                    for (;t && (t = Nl.call(t)) && (xl(t) !== 8 || !t.nodeValue?.startsWith(ss)); ) {}
                }
            }
        }
    }
    return t;
};

function mn(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = Ol(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const Ol = Fo("parentNode");

let jl = null;

const Ll = t => {
    jl || (jl = Lo(t, "firstChild"));
    t = t && jl.call(t);
    if (t && xl(t) === 8) {
        Nl || (Nl = Lo(t, "nextSibling"));
        if (t.nodeValue?.startsWith(ts)) {
            return mn(t, Ke, Nl, jl);
        }
    }
    for (;t && !Il(t); ) {
        t = Cl(t);
    }
    return t;
};

const Fl = Fo("namespaceURI");

const Xl = Fo("nodeName");

const Dl = Fo("ownerDocument");

const Wl = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;Kl(i) && vn(i); ) {
            i = Cl(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = xl(i);
        let e = null;
        if (n === 3) {
            e = Wo(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = Do(i);
            tl(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = Cl(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        Vl(e, (e, s) => {
            if (e() === 61) {
                n || (n = se(t.node));
                const e = s();
                n.xn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = se(t.node));
                wn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function wn(t, n, e) {
    if (t[vr]) {
        const s = t[vr];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e._(n));
    } else {
        Object.defineProperty(t, vr, {
            get() {
                const s = e._(n);
                t[vr] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, vr, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const Vl = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e);
    }
};

const Ul = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        nl(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(Es) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const zl = (t, n) => {
    let e = Bl(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = Bl(e);
    }
    return !1;
};

const Bl = t => t.parent || t.slotParent;

const Hl = t => {
    if (t === null || Qo(t)) {
        return null;
    }
    return t.node;
};

function bn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (zo(e)) {
                        const t = ie(e.node);
                        if (!t) {
                            return null;
                        }
                        return re(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (Jo(i)) {
            c.push(Pn(Sl(i)));
        } else if (Qo(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = Ul(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== xe && e !== "__scopedStyleIdPrefix__") {
                        const t = Go(i, e, null);
                        s.push(" " + e + "=" + Pn(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (Ie[Go(i, xe, null) || "V"] || Ie.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Rl(i);
            u && c.push("  " + bn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (zo(i)) {
            const s = El(i);
            const l = [];
            cn(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? Ul(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = Go(i, n, null);
                l.push(" " + n + "=" + Pn(e));
            }
            const f = Hl(i);
            if (f) {
                const t = Dl(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + Pn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + Pn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (Ho(i) || e) {
                const e = Rl(i);
                e && c.push("  " + bn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const Jl = t => 48 <= t && t <= 57;

const Ql = t => 97 <= t && t <= 122;

function vn(t) {
    return !t.hasAttribute(Es) || t.nodeName === "STYLE" && (t.hasAttribute(He) || t.hasAttribute(Ue));
}

const Yl = [];

const Gl = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw qe(26, [ n ]);
};

const Kl = t => t && typeof t == "object" && xl(t) === 1;

const Zl = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!Qo(t) || Go(t, Le, null) === null); ) {
            const e = t.slotParent;
            const s = Qo(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function _n(t, n) {
    Uo(n) && zo(n) && Pl(n);
    const e = n[vr];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        gn(t, n);
    }
    e.clear();
}

function gn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof Hr) {
            Sn(s, n);
        } else if (s instanceof Ur) {
            En(t, s, n);
        } else if (ci(s)) {
            const t = s[Gr];
            kn(t, n);
        } else if (t.dt.has(s)) {
            const e = t.dt.get(s);
            const o = $u(e);
            kn(o, n);
        }
    }
    e.clear();
}

function En(t, n, e) {
    const s = n.ct;
    s && s.has(e) && s.delete(e);
    if (n instanceof ki && !s?.size) {
        n.m = void 0;
        _n(t, n);
    }
}

function Sn(t, n) {
    const e = t.ct;
    e && e.has(n) && e.delete(n);
    const s = t.$t;
    s && s.has(n) && s.delete(n);
    const o = t.yt;
    o && o.has(n) && o.delete(n);
    t.wt();
}

function kn(t, n) {
    const e = t?.ct;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const tu = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = wo();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new eu(6 | i, r, o.m, t, void 0, null);
    s(c);
    const l = o.$;
    const {Xt: u} = o;
    const f = qs(u, () => nu(c, l, o.m));
    Ps(f) && (o.Xt = f);
};

const nu = (t, n, e) => {
    const s = t.In;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let r = null;
    const i = qs(((t, n) => {
        const e = t.Nn;
        if (e) {
            return e;
        }
        const s = t.Tn;
        if (!s) {
            return;
        }
        t.Tn = null;
        try {
            const e = s();
            if (Ps(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Nn === s && (t.Nn = void 0);
                });
                t.Nn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = he(n.jt, e, "qTask");
        s.$ = n;
        const i = t.bt.getFn(s, () => _n(n, t));
        const c = Vr(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.Tn = () => {
                            t.Tn = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    Ps(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return Ts(() => i(u), l, s => {
            if (Ps(s)) {
                return s.then(() => {
                    t.In === r && (t.In = null);
                    return nu(t, n, e);
                });
            }
            o(s);
        });
    });
    if (Ps(i)) {
        r = i.finally(() => {
            t.In === r && (t.In = null);
        });
        t.In = r;
        return r;
    }
    return i;
};

class eu extends _r {
    h;
    Qt;
    ft;
    bt;
    Ot;
    Tn;
    Nn;
    In=null;
    constructor(t, n, e, s, o, r) {
        super();
        this.h = t;
        this.Qt = n;
        this.ft = e;
        this.bt = s;
        this.Ot = o;
        this.Tn = r;
    }
}

const su = t => t instanceof eu;

function Rn(t, n) {
    const e = se(n);
    typeof this === "string" && kf(Rf(e, this));
    const s = Sf[0];
    s.h |= 4;
    hn(e, s.ft, 1);
}

const ru = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const iu = t => t instanceof Ur;

const ou = (t, n) => {
    t.add(n);
};

const lu = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const uu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        su(e) ? o = e.bt : e instanceof zr ? o = e.en : s === ":" && (o = n.getHostProp(e, Le));
        o && n.serializationCtx.xt.add(o);
    }
};

const cu = (t, n) => {
    if (t && (!n || t === n || Mh(t))) {
        return t;
    }
    return n;
};

const fu = (t, n, e) => {
    const s = ye;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (su(o)) {
                o.h |= 4;
                hn(t, o.ft, 1);
            } else if (o instanceof Ur) {
                o.invalidate();
            } else if (r === ":") {
                hn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Xt(o, n);
                    hn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof Ri) {
                    const e = i.data;
                    const c = {
                        isConst: e.et,
                        scopedStyleIdPrefix: e.O,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[Ir];
                            if (!o) {
                                o = new Map;
                                s[Ir] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(Ir);
                        if (!n) {
                            n = new Map;
                            t.setProp(Ir, n);
                        }
                        n.set(r, c);
                    }
                    hn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const au = t => ke(t) && typeof t[jc] === "function";

const hu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const du = [];

function Pn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (su(t)) {
            return `Task(${Pn(t.bt)})`;
        }
        if (Ae(t)) {
            return `Qrl(${t.vt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (du.includes(t)) {
                return "*";
            }
            du.length;
            try {
                du.push(t);
                if (Array.isArray(t)) {
                    return Uo(t) ? "(" + (Go(t, xe, null) || "vnode") + ")" : t.map(Pn);
                }
                if (iu(t)) {
                    return t instanceof ki ? "WrappedSignal" : t instanceof zr ? "ComputedSignal" : "Signal";
                }
                if (vu(t)) {
                    return "Store";
                }
                if (qi(t)) {
                    return pu(t);
                }
                if (Uo(t)) {
                    return "(" + (Go(t, xe, null) || "vnode") + ")";
                }
            } finally {
                du.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const pu = t => {
    if (qi(t)) {
        if (typeof t.type === "function") {
            const n = t.type[Vf];
            if (n) {
                const [t] = n;
                return "Component(" + t.vt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + Pn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += pu(e);
                    }
                } else {
                    n += pu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const $u = t => t[Dr];

const yu = t => t?.[Xr] || null;

const mu = (t, n) => {
    const e = $u(t);
    e && e.force(n);
};

const wu = (t, n) => {
    const e = $u(t);
    if (e) {
        return (e.ct?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const bu = t => yu(t) || t;

const vu = t => Xr in t;

function Tn(t, n, e) {
    return new Proxy(n, new gu(e, t || null));
}

const _u = (t, n, e) => {
    if (Se(t) && e) {
        let s = e.dt.get(t);
        if (!s) {
            s = Tn(e, t, n);
            e.dt.set(t, s);
        }
        return s;
    }
    return t;
};

class gu {
    h;
    $;
    ct=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = yu(this);
        fu(this.$, this, An(n, t, this.ct));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === Xr) {
                return t;
            }
            if (n === Dr) {
                return this;
            }
            return t[n];
        }
        const e = ef();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.Ft;
            o && qn(t, Array.isArray(t) ? Wr : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && ke(s) && !Object.isFrozen(s) && !vu(s) && !Object.isFrozen(t)) {
            return _u(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? bu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && Mn(n, s, t, this);
        } else {
            Mn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || fu(this.$, this, An(t, n, this.ct));
        return !0;
    }
    has(t, n) {
        if (n === Xr) {
            return !0;
        }
        if (typeof n === "string") {
            const e = ef();
            if (e) {
                const s = e.Ft;
                s && qn(t, Array.isArray(t) ? Wr : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = ef();
        const e = n?.Ft;
        e && qn(t, Wr, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function qn(t, n, e, s, o) {
    const r = e.ct ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = $e;
    const l = __EXPERIMENTAL__.suspense && e instanceof gu && c;
    ou(i, s);
    lu(s, t);
    if (c) {
        const i = cu(o, e.$);
        l && i?.nn?.(t, s, n, r);
        uu(s, i);
    }
}

function Mn(t, n, e, s) {
    e[t] = n;
    const o = An(e, t, s.ct);
    o && fu(s.$, s, o);
}

function An(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(Wr);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const Eu = Symbol();

const Su = [ void 0, null, !0, !1, "", ti, ni, Lr, Wr, Zr, Yi, Ji, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER ];

const ku = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER" ];

const Ru = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch" ];

function xn(t, n, e) {
    let s = n.vt;
    let o = n._t;
    const r = Hs();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => Ae(t) && t.vt == Me)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.gt(null, 0, e) + "";
    } else {
        o || (o = t.Et(n.it));
        if (!o) {
            throw qe(14, [ n.vt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    c && c.length > 0 && (l = c.map(n => "" + t.St(n)).join(" "));
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function In(t, n, e, s) {
    return Mf(t, n, null, null, e, s);
}

function Nn(t, n) {
    const [e, s, o] = t.split("#");
    return In(e, s, o || null, n);
}

class Pu {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class Tu {
    On;
    jn=0;
    Rt=[];
    Ln=0;
    Fn=new Set;
    Xn=new Map;
    Dn;
    Wn=new Map;
    Vn=0;
    Nt;
    Un=typeof Temporal !== "undefined";
    constructor(t) {
        this.On = t;
        this.Nt = t.Nt;
    }
    async serialize() {
        const t = this.Vn;
        this.Vn = 0;
        try {
            await this.outputRoots();
        } finally {
            this.Vn = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.Vn;
        this.Vn = s;
        this.Nt.write($r);
        this.On.zn = 0;
        try {
            this.Nt.write(t + "");
            this.Nt.write(mr);
            this.Nt.write($r);
            await this.outputSelectedRoots(n);
            this.Nt.write(yr);
            const s = this.getForwardRefsPayload();
            this.On.zn = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Nt.write(mr);
                s ? this.outputForwardRefsArray(s) : this.Nt.write("0");
            }
            if (e !== void 0) {
                this.Nt.write(mr);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Nt.write(pr);
                    this.writeRootRefPath(e);
                    this.Nt.write(pr);
                }
            }
        } finally {
            this.Vn = o;
        }
        this.Nt.write(yr);
    }
    Bn(t) {
        this.Nt = t;
    }
    outputArray(t, n, e) {
        this.Nt.write($r);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Nt.write(mr) : s = !0;
            e(t[n], n);
        }
        this.Nt.write(yr);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : pr + t + pr;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Nt.write(n.slice(s, e));
            this.Nt.write("<\\/");
            s = e + 2;
        }
        this.Nt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Nt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Nt.writeRootRefPath(t);
    }
    outputStringChunks(t) {
        this.Nt.write(pr);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Nt.write(e) : typeof e === "number" ? this.writeRootRef(e) : this.writeRootRefPath(e.path);
        }
        this.Nt.write(pr);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Nt.write(t + mr);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Nt.write(pr);
                this.writeRootRefPath(n);
                this.Nt.write(pr);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Nt.write(t + mr);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Nt.write(t + mr + n);
        } else if (typeof n === "string") {
            this.Nt.write(t + mr);
            this.outputString(n);
        } else {
            this.Nt.write(t + mr);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.On.getSeenRef(t);
        const o = !e && this.Xn.get(t);
        if (s) {
            s.Dn && this.isSeenInStreamedRoot(s) && (s = this.On.Hn(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.On.Jn(t, this.Dn, n);
            }
            s = this.On.St(t, !0);
        }
        if (s.Dn) {
            if (this.Dn) {
                this.On.Qn(s, t);
            } else {
                this.On.Qn(s, t, n);
                t = this.On.Yn[n];
            }
        }
        if (typeof o === "number") {
            this.Rt[o] = s.Qt;
            this.Xn.delete(t);
        }
        const r = t instanceof Cu ? t.Gn : s.Qt;
        if (!this.Dn && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.Dn; ) {
            t = t.Dn;
        }
        return t.Qt < this.Vn;
    }
    writeValue(t, n) {
        if (Nc(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                t.length === 0 ? this.output(3, 4) : (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === Lr) {
                    this.output(3, 7);
                } else if (t === Wr) {
                    this.output(3, 8);
                } else if (t === Zr) {
                    this.output(3, 9);
                } else {
                    if (t !== Eu) {
                        throw qe(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === Yi) {
                    this.output(3, 10);
                } else if (t === Ji) {
                    this.output(3, 11);
                } else if (Ae(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = xn(this.On, t, !0);
                        let o;
                        if (n !== "") {
                            o = [ this.On.St(n), "#", this.On.St(e) ];
                            if (s) {
                                const t = s.split(" ");
                                o.push("#");
                                for (let n = 0; n < t.length; n++) {
                                    n > 0 && o.push(" ");
                                    o.push(+t[n]);
                                }
                            }
                            const r = o.join("");
                            const i = this.Wn.get(r);
                            if (i) {
                                const t = this.On.St(i);
                                this.output(1, t);
                                return;
                            }
                            this.Wn.set(r, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!Uf(t)) {
                        throw qe(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[Vf];
                        this.On.Kn.add(n.vt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === ti) {
                    this.output(3, 5);
                } else if (t === ni) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof Cu) {
                    this.output(1, t.Gn);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.Dn;
                        this.Dn = e;
                        this.writeObjectValue(t);
                        this.Dn = n;
                    }
                }
                break;

              default:
                throw qe(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (ci(t)) {
            const n = t[Yr];
            this.output(38, [ Iu(n), n.varProps, n.constProps, t[Gr].ct ]);
        } else if (t instanceof Ri) {
            this.output(39, [ t.data.O, t.data.et ]);
        } else if (t instanceof Fr) {
            this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof Pu) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (vu(t)) {
            const n = $u(t);
            const e = yu(t);
            const s = n.h;
            const o = n.ct;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.On.dt.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (au(t)) {
            const n = t[jc](t);
            if (Ps(n)) {
                const t = this.resolvePromise(n, (t, n) => new qu(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.Dn.Qt;
                this.Dn = this.Dn.Dn;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        Nc(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.On.Zn(t)) {
            this.On.te(t.ne, 16);
            this.output(11, t.ne.id);
        } else if (t instanceof Ur) {
            if (t instanceof ai) {
                const n = function e(t, n) {
                    if (n === Lr) {
                        return n;
                    }
                    return qs(t.en.resolved || t.en.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && jc in n && (e = n[jc](n));
                        e === void 0 && (e = Lr);
                        return e;
                    });
                }(t, t.Zt);
                if (Ps(n)) {
                    const e = this.resolvePromise(n, (n, e) => new qu(34, n, e, t.ct, t.en));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.en, t.ct, n ]);
                }
                return;
            }
            if (t instanceof ki) {
                this.output(31, [ ...Cn(this.On, t), t.h, t.m, ...t.ct || [] ]);
            } else if (t instanceof zr) {
                let n = t.Zt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = Nc(t.Zt);
                const i = t instanceof Hr;
                const c = i && t.Pt !== 0 ? t.Pt : void 0;
                const l = i && t.yn !== 1 ? t.yn : void 0;
                const u = i && t.wn !== 0 ? t.wn : void 0;
                const f = i && t.h & -25 || void 0;
                o || r ? n = Lr : e ? n = t.Zt : s && (n = Lr);
                const a = [ t.en, t.ct ];
                if (i) {
                    a.push(t.$t, t.yt, t.pn);
                    a.push(f || void 0);
                }
                n === Lr && c === void 0 && l === void 0 && u === void 0 || a.push(n === void 0 ? Eu : n);
                if (i) {
                    a.push(c);
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Zt;
                const e = [ n === void 0 ? Eu : n ];
                t.ct && e.push(...t.ct);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (this.Un && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.Un && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.Un && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.Un && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.On.ee(t)) {
            const n = this.On.St(t);
            this.On.se(t, as, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                Mu(e, t => {
                    this.On.St(t);
                });
                this.On.te(t, 16);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.On.te(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (qi(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof eu) {
            const n = [ t.bt, t.h, t.Qt, t.ft, t.Ot ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (Ps(t)) {
            const n = this.resolvePromise(t, (t, n) => new qu(24, t, n));
            this.output(2, n);
        } else if (t instanceof qu) {
            if (t.re === 34) {
                if (t.bt) {
                    this.output(34, [ t.bt, t.ct, t.ie ]);
                } else {
                    if (!t.oe) {
                        console.error(t.ie);
                        throw qe(33);
                    }
                    {
                        const n = this.Dn.Qt;
                        this.Dn = this.Dn.Dn;
                        this.writeValue(t.ie, n);
                    }
                }
            } else {
                this.output(24, [ t.oe, t.ie ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof xu) {
            const n = t.le;
            if (this.getSeenRefOrOutput(n, this.Dn.Qt, !0)) {
                let t = this.Xn.get(n);
                if (t === void 0) {
                    t = this.Ln++;
                    this.Xn.set(n, t);
                    this.Rt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else {
            if (!Uo(t)) {
                throw qe(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Ln++;
        t.then(s => {
            this.Fn.delete(t);
            this.Rt[e] = this.On.St(n(!0, s));
        }).catch(s => {
            this.Fn.delete(t);
            this.Rt[e] = this.On.St(n(!1, s));
        });
        this.Fn.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.On.ue + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {Yn: n} = this.On;
        for (;this.jn < n.length || this.Fn.size; ) {
            let e = t > 0;
            for (;this.jn < n.length; this.jn++) {
                e ? this.Nt.write(mr) : e = !0;
                this.writeValue(n[this.jn], this.jn);
                t++;
            }
            if (this.Fn.size) {
                try {
                    await Promise.race(this.Fn);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.Fn.size; ) {
            if (e < t.length) {
                n ? this.Nt.write(mr) : n = !0;
                const s = t[e++];
                this.writeValue(this.On.Yn[s], s);
                continue;
            }
            try {
                await Promise.race(this.Fn);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Rt.length - 1;
        for (;t >= 0 && this.Rt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Rt.length - 1 ? this.Rt : this.Rt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Nt.write(pr);
                this.writeRootRefPath(t);
                this.Nt.write(pr);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Nt.write($r);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.On.ce = this.On.Yn.length;
        this.On.fe = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Nt.write(mr);
            this.Nt.write(14 + mr);
            this.outputForwardRefsArray(n);
        }
        this.Nt.write(yr);
        this.On.ae = this.On.Yn.length + (this.On.fe ? 1 : 0);
        this.On.zn = e;
    }
}

class qu {
    re;
    oe;
    ie;
    ct;
    bt;
    constructor(t, n, e, s, o) {
        this.re = t;
        this.oe = n;
        this.ie = e;
        this.ct = s;
        this.bt = o;
    }
}

const Mu = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (Au(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === as || t === ds && hr(s)) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const Au = t => typeof t === "object" && t !== null && !hr(t);

function Cn(t, n) {
    n.kt && n.kt[0] === "{" && (n.kt = `(${n.kt})`);
    const e = t.gt(n.kt, n.lt.length, n.ot);
    return [ e, n.lt ];
}

class xu {
    le;
    constructor(t) {
        this.le = t;
    }
}

const Iu = t => new xu(t);

let Nu = () => !1;

class Cu {
    Gn;
    constructor(t) {
        this.Gn = t;
    }
}

class Ou {
    NodeConstructor;
    DomRefConstructor;
    Et;
    se;
    dt;
    Nt;
    he=new Map;
    de=new Map;
    pe=0;
    $e=[];
    Yn=[];
    ye=[];
    me;
    ue=0;
    ae=0;
    zn=0;
    ce=0;
    fe=!1;
    Tt=new Set;
    xt=new Set;
    At=new Set;
    Kn=new Set;
    we;
    te=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.Et = e;
        this.se = s;
        this.dt = o;
        this.Nt = r;
        this.we = new Tu(this);
    }
    async It() {
        await this.we.serialize();
    }
    async be(t, n, e, s) {
        await this.we.serializePatch(t, n, e, s);
    }
    Bn(t) {
        this.Nt = t;
        this.we.Bn(t);
    }
    getSeenRef(t) {
        return this.he.get(t);
    }
    Jn(t, n, e) {
        const s = {
            Qt: e,
            Dn: n
        };
        this.he.set(t, s);
        return s;
    }
    ve(t) {
        const n = [];
        for (;t.Dn; ) {
            n.unshift(t.Qt);
            t = t.Dn;
        }
        n.unshift(t.Qt);
        return n;
    }
    Qn(t, n, e) {
        const s = this.ve(t);
        const o = e === void 0;
        e === void 0 && (e = this.Yn.length);
        this.Yn[e] = new Cu(s);
        o && (this.ye[e] = n);
        t.Dn = null;
        t.Qt = e;
        o && this.me?.(e, this.Yn[e], n);
    }
    St(t, n = !1) {
        let e = this.he.get(t);
        let s;
        if (e) {
            e.Dn && this.Qn(e, t);
            s = e.Qt;
        } else {
            s = this.Yn.length;
            e = {
                Qt: s
            };
            this.he.set(t, e);
            this.Yn.push(t);
            this.ye.push(t);
            this.me?.(s, t, t);
        }
        return n ? e : s;
    }
    Hn(t) {
        const n = this.Yn.length;
        const e = {
            Qt: n
        };
        this.he.set(t, e);
        this.Yn.push(t);
        this.ye.push(t);
        this.me?.(n, t, t);
        return e;
    }
    _e(t, n) {
        const e = this.Yn.length;
        const s = {
            Qt: e
        };
        this.he.set(n, s);
        this.Yn.push(t);
        this.ye.push(n);
        return e;
    }
    ee(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    Zn(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    ge(t) {
        const n = this.he.get(t);
        return n && (n.Dn ? void 0 : n.Qt);
    }
    gt(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.de.get(t);
        if (o === void 0) {
            o = this.pe + this.$e.length;
            this.de.set(t, o);
            if (s) {
                this.$e.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.$e.push(e += ")=>" + t);
            }
        }
        return o;
    }
    Ee(t, n) {
        this.pe = t;
        if (n) {
            this.de.clear();
            for (let t = 0; t < n.length; t++) {
                this.de.set(n[t], t);
            }
        }
    }
}

const ju = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(dr(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    Nu = n ? t => t instanceof n : () => !1;
    return new Ou(t, n, e, s, o, r);
};

const Lu = (t, n) => t[n];

const Fu = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        vu(t) && (t = yu(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!Fu(lf(Lu, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!Fu(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (su(t)) {
            return !0;
        }
        if (ci(t)) {
            return !0;
        }
        if (Ps(t)) {
            return !0;
        }
        if (qi(t)) {
            return !0;
        }
        if (au(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Ri) {
            return !0;
        }
        if (Nu?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (Ae(t) || Uf(t) || t === Yi || t === Ji) {
            return !0;
        }
    } else if (t === Zr || t === Lr || t === Wr) {
        return !0;
    }
    return !1;
};

const Xu = (t, n) => {
    let e = Uo(t) ? bn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (ke(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let Du = !1;

const Wu = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (Du = !0);
            const n = `{${ke(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${Xu(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = Uu(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${Wu(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${Vu(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = Du ? "" : `(${JSON.stringify(t).length} chars)`;
        Du = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const Vu = t => Ru[t] || `Unknown(${t})`;

const Uu = t => ku[t] || `Unknown(${t})`;

function On(t, n, e, s = 0) {
    const o = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const r = t => t === 14;
    const i = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let e = s; e < t.length; e += 2) {
        o(t[e], t[e + 1]) ? i(e) : r(t[e]) && (n.Rt = t[e + 1]);
    }
}

const zu = new WeakMap;

const Bu = new Map;

const Hu = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t._(e);

      case 2:
        const s = t.Ct(e);
        return s === -1 || s === void 0 ? Zr : t._(s);

      case 14:
        return e;

      case 3:
        return Su[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const [s, o, r] = e.split("#");
                const i = t._(s);
                const c = t._(o);
                n = In(i, c, r || null, t);
            } else {
                n = In("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new eu(-1, -1, null, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return Wf(null);

      case 30:
        return new Ur(t, 0);

      case 31:
        return new ki(t, null, null, null);

      case 32:
        return new zr(t, null);

      case 33:
        return new Hr(t, null, void 0, {});

      case 34:
        return new ai(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = Hu(t, s, o);
            const i = _u(r, 0, t);
            kc(s) && Bu.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new Pi(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        zu.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        const l = e.length;
        const u = l >>> 2;
        const f = l & 3;
        const a = u * 3 + (f ? f - 1 : 0);
        return new Uint8Array(a);

      case 38:
        return w(null);

      case 10:
        return jn(t, e);

      case 11:
        const h = jn(t, e);
        if (Uo(h)) {
            Pl(h);
            return Hl(h);
        }
        throw qe(17, [ typeof h ]);

      case 39:
        return new Ri({});

      case 40:
        return new Fr(null, null, null, null);

      case 41:
        return new Pu;

      default:
        throw qe(18, [ n ]);
    }
};

function jn(t, n) {
    return n ? t.rootVNode ? il(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Ju = (t, n, e) => {
    let s = null;
    let o = null;
    if (Te(t)) {
        o = t;
    } else {
        if (!Pe(t)) {
            throw qe(7, [ t ]);
        }
        s = t;
    }
    return Mf(s, n, null, o, e);
};

const Qu = (t, n, e) => Mf(null, n, t, null, e);

const Yu = (t, n) => Mf(null, t, null, null, n);

const Gu = (t, n, e) => {
    const s = Yu(t, e);
    return s;
};

const Ku = (t, n, e, s) => Mf(t, e, null, n, s);

const Zu = (t, n, e, s, o) => {
    const r = Ku(t, n, e, o);
    r.Se(s);
    return r;
};

const tc = (t, n, e, s) => {
    const o = Ju(t, n, s);
    return o;
};

const nc = (t, n, e, s) => {
    const o = Qu(t, n, s);
    return o;
};

const ec = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const sc = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Ln(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const rc = (t, n, e) => new ki(null, t, n, e || null);

class ic {
    ke;
    dt;
    Re=null;
    Cn=!1;
    jt;
    _;
    Dt;
    Pe=0;
    Te=null;
    qe=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.Dt = t;
        this.jt = n;
        this.ke = wr;
        this.dt = new WeakMap;
        this._ = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return ff(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return ju(t, n, e, this.setHostProp.bind(this), this.dt, s);
    }
    ht() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const oc = Symbol();

const Ih = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[oc] = t;
    return n;
};

class lc {}

function Fn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function Xn(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === lc) {
                    const t = o.pop();
                    await n(() => o.push(t()));
                    continue;
                }
                if (typeof e === "function") {
                    if (e === Promise) {
                        o.push(await o.pop());
                    } else {
                        const n = e.apply(t);
                        Ps(n) && await n;
                    }
                    continue;
                }
                Dn(t, r, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                Ps(n) && await n;
            }
        }
    })();
}

function Dn(t, n, e, s) {
    if (e == null) {
        t.textNode("");
    } else if (typeof e === "boolean") {
        t.textNode("");
    } else if (typeof e === "number") {
        t.textNode(e + "");
    } else if (typeof e === "string") {
        t.textNode(e);
    } else if (typeof e === "object") {
        if (Array.isArray(e)) {
            for (let t = e.length - 1; t >= 0; t--) {
                n(e[t]);
            }
        } else if (iu(e)) {
            (function s(t, n) {
                const e = n instanceof ki ? n.rt() : n;
                if (e instanceof Hr) {
                    const n = e.Pt;
                    if (n && !(e.h & 256)) {
                        t.St(e);
                        t.Tt.add(e);
                    }
                }
            })(t.serializationCtx, e);
            t.openFragment(ni);
            const o = t.getOrCreateLastNode();
            const r = e instanceof ki ? e.rt() : e;
            n(t.closeFragment);
            n(() => ff(r, o, ".", t));
            n(lc);
        } else if (Ps(e)) {
            t.openFragment(ni);
            n(t.closeFragment);
            n(e);
            n(Promise);
            n(() => t.streamHandler.flush());
        } else if (function o(t) {
            return !!t[Symbol.asyncIterator];
        }(e)) {
            n(async () => {
                for await (const n of e) {
                    await Xn(t, n, {
                        currentStyleScoped: s.currentStyleScoped,
                        parentComponentFrame: s.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const o = e;
            const r = o.type;
            if (typeof r === "string") {
                (function e(t, n) {
                    const e = ii(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(o, s.currentStyleScoped);
                let i = null;
                const c = t.openElement(r, o.key, o.varProps, o.constProps, s.currentStyleScoped, i, !!(o.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (r === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (r === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.qt) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = o.children;
                l != null && n(l);
            } else if (Te(r)) {
                if (__EXPERIMENTAL__.suspense && (t => typeof t === "function" && oc in t)(r)) {
                    n(() => (t => t[oc])(r)(t, o, s, n));
                    return;
                }
                if (r === Ji) {
                    const e = o.key != null ? {
                        [hs]: o.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = o.children;
                    s != null && n(s);
                } else if (r === Yi) {
                    const e = s.parentComponentFrame;
                    if (e) {
                        const r = e.componentNode.id || "";
                        const i = {};
                        const c = ii(o, rs);
                        c && (i[rs] = c);
                        i["q:sparent"] = r;
                        t.openProjection(i);
                        const l = e.componentNode;
                        const u = t.getOrCreateLastNode();
                        const f = k(l, o, t);
                        i[De] = f;
                        n(Fn(s, s.currentStyleScoped, s.parentComponentFrame));
                        n(t.closeProjection);
                        const a = o.children || null;
                        const h = e.consumeChildrenForSlot(u, f) || a;
                        a && h !== a && t.addUnclaimedProjection(e, "", a);
                        n(h);
                        n(Fn(s, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = ni;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (r === Zi) {
                    t.commentNode(ii(o, "data") || "");
                } else if (r === no) {
                    t.streamHandler.flush();
                    const e = o.children;
                    let r;
                    r = Te(e) ? e({
                        async write(n) {
                            await Xn(t, n, {
                                currentStyleScoped: s.currentStyleScoped,
                                parentComponentFrame: s.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : e;
                    n(r);
                    Ps(r) && n(Promise);
                } else if (r === Ki) {
                    t.htmlNode(ii(o, "data"));
                } else if (r === to) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(o.children);
                } else if (Uf(r)) {
                    const e = {};
                    t.openComponent(e);
                    const i = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(o.children, s.currentStyleScoped, s.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[Vf];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(Le, o);
                        s.setProp(ds, r);
                        n.key !== null && s.setProp(hs, n.key);
                        return To(t, s, s, o, r);
                    })(t, o, r);
                    n(Fn(s, s.currentStyleScoped, s.parentComponentFrame));
                    n(() => t.closeComponent());
                    if (Ps(l)) {
                        n(async () => {
                            const t = await l;
                            const e = xs(i.getProp(He));
                            n(t);
                            n(Fn(s, e, c));
                        });
                    } else {
                        n(l);
                        const t = xs(i.getProp(He));
                        n(Fn(s, t, c));
                    }
                } else {
                    const e = {
                        [hs]: o.key
                    };
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = t.getParentComponentFrame();
                    const i = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return To(t, o, n, e, s.props);
                    })(t, s && s.componentNode, r, o);
                    n(i);
                    Ps(i) && n(Promise);
                }
            }
        }
    }
}

const uc = () => Sf;

const cc = async t => {
    const [n, e] = Sf;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = Tn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const fc = (t, n) => {
    const {val: e, set: s, iCtx: o} = wo();
    if (e) {
        return e;
    }
    const r = Mf(null, "_rsc", cc, null, [ t, {} ], o.$);
    const i = di(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const ac = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (Ps(t)) {
        return t.then(n, s);
    }
    const o = hc(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return Ps(i) ? i.then(n, s) : n(i);
};

const hc = t => t && t.__brand === "resource";

function Wn(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        n.vt.startsWith("_") || !n.Mt?.length && !s || (n = Mf(null, "_run", I, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = xn(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            const c = o.split(" ");
            for (let t = 0; t < c.length; t++) {
                t > 0 && i.push(" ");
                i.push(+c[t]);
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (Ae(o)) {
                i(c(o));
                Vn(t, n, o);
            } else if (o != null) {
                const e = Wn(t, n, o, s);
                e && i(e);
            }
        }
    } else if (Ae(r)) {
        o = c(r);
        Vn(t, n, r);
    }
    return o;
}

function Vn(t, n, e) {
    const s = Os(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.At.add(r);
        t.xt.add(e);
    }
}

const dc = (t, n, e) => {
    yc(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const pc = (t, n, e) => {
    yc(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const $c = (t, n, e) => {
    yc(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const yc = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = mc();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + Cs(i), e, s);
            }
        } else {
            r(t + Cs(n), e, s);
        }
    }
};

const mc = () => {
    const t = rf();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, bs);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, bs, s);
    }
    let o = t.$.getHostProp(e, vs);
    o === null && (o = 0);
    t.$.setHostProp(e, vs, o + 1);
    let r = t.$.getHostProp(e, _s);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, _s, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const wc = function(t, n) {
    if (!t.detail.files.some(t => n.getAttribute("data-qwik-inspector")?.startsWith(t))) {
        return;
    }
    if (typeof this === "string") {
        const t = se(n);
        kf(Rf(t, this));
    }
    const e = Sf[0];
    const s = se(n);
    hn(s, e, 4);
    const o = n.ownerDocument;
    o.__hmrDone = o.__hmrT;
};

let bc;

function Un() {
    const t = ef();
    if (!t) {
        return;
    }
    bc ||= Qu(wc, "_hmr");
    const n = t.m;
    const e = bc.w([ n ]);
    pc("qHmr", e);
}

function zn(t, n, e, s, o) {
    const r = Vo();
    Ko(r, De, o);
    r.parent = n;
    Ko(n, o, r);
    Ko(r, Le, e);
    Ko(r, ds, s);
    r.dirty = 4;
    un(t, r, 1);
    return r;
}

function Bn(t, n) {
    Ko(t, Fe, n);
    t.flags |= 2048;
}

function Hn(t, n, e) {
    Ko(n, ds, e);
    hn(t, n, 4);
}

function Jn(t, n, e, s) {
    Ko(n, s, null);
    const o = [];
    Et(t, o, e);
    al(o);
    if (e.flags & 2048) {
        const t = Go(e, Fe, null);
        t && t.replaceChildren();
        Ko(e, Fe, null);
        e.flags &= -2049;
    }
}

let vc = Promise.resolve();

const _c = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const gc = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !_c.has(t));
};

const Ec = (t, n, e, s) => {
    if (e === 0) {
        return;
    }
    e !== 4 && Array.isArray(s) && (s = Sc(t, s));
    switch (e) {
      case 4:
        Sc(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!gc(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 28:
        const o = n;
        const r = s;
        o.bt = r[0];
        o.h = r[1];
        o.Qt = r[2];
        o.ft = r[3];
        o.Ot = r[4];
        break;

      case 29:
        n[Vf][0] = s[0];
        break;

      case 35:
        {
            const e = bu(n);
            const o = Bu.get(e);
            if (o) {
                Bu.delete(e);
                Ec(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = $u(n);
            c.h = r;
            c.ct = i;
            Gn(c.ct, e);
            break;
        }

      case 30:
        {
            const t = n;
            const e = s;
            t.Zt = e[0];
            t.ct = new Set(e.slice(1));
            Yn(t.ct, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ot = t.getSyncFn(o[0]);
            e.lt = o[1];
            e.Zt = Lr;
            e.h = o[2];
            e.h |= 1;
            e.m = o[3];
            e.ct = new Set(o.slice(4));
            (function r(t) {
                if (t.m !== null && Uo(t.m)) {
                    const n = t.m;
                    const e = t.ct;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (Pe(e)) {
                                const o = Go(n, e, null);
                                if (o !== null) {
                                    t.Zt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Rl(n);
                        e && n.firstChild === n.lastChild && Jo(e) && (t.Zt = Sl(e));
                    }
                }
            })(e);
            Yn(e.ct, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.en = e[0];
            e[1] && (t.ct = new Set(e[1]));
            e[2] && (t.$t = new Set(e[2]));
            e[3] && (t.yt = new Set(e[3]));
            e[4] && (t.pn = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.dn = !0);
            const o = e.length > 6;
            o && (t.Zt = e[6]);
            t.Zt === Lr && (t.h |= 1);
            const r = e[7] ?? 0;
            t.expires = Math.abs(r);
            r < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.yn = e[8] ?? 1;
                t.mn = [];
            }
            t.wn = e[9] ?? 0;
            Yn(t.ct, t);
            Yn(t.$t, t);
            Yn(t.yt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.en = r[0];
            const i = o.en.resolve(t).catch(() => {});
            vc = vc.finally(() => i);
            r[1] && (o.ct = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Zt = r[2]);
            e !== 34 && o.Zt !== Lr && (o.h &= -2);
            Yn(o.ct, o);
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                n[t[e]] = t[e + 1];
            }
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = zu.get(t);
            e ? r(o) : i(o);
            break;
        }

      case 27:
        const i = n;
        const c = atob(s);
        let l = 0;
        for (let t = 0; t < c.length; t++) {
            const n = c[t];
            i[l++] = n.charCodeAt(0);
        }
        break;

      case 38:
        const u = n;
        const f = s;
        let a = f[0];
        if (a === Zr) {
            a = new Pi(Ji, f[1], f[2], null, 0, null);
            a._proxy = u;
        }
        u[Yr] = a;
        const h = u[Gr];
        h.ct = f[3];
        Gn(h.ct, u);
        break;

      case 39:
        {
            const t = n;
            t.data.O = s[0];
            t.data.et = s[1];
            break;
        }

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            (function o(t) {
                const n = $e;
                const e = t.consumer;
                if (n && !e) {
                    return;
                }
                e[vr] ||= new Map;
                e[vr].set(t.property, t);
            })(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      default:
        throw qe(16, [ e ]);
    }
};

const Sc = (t, n, e = Array(n.length / 2)) => {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = Qn(t, n[s], n[s + 1]);
    }
    return e;
};

function Qn(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = Hu(t, n, e);
    kc(n) && Ec(t, s, n, e);
    return s;
}

function Yn(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function Gn(t, n) {
    if (t) {
        for (const [, e] of t) {
            Yn(e, n);
        }
    }
}

const kc = t => t >= 23 || t === 4 || t === 5;

const Rc = new WeakMap;

const Pc = Symbol();

const Tc = (t, n) => {
    if (!Array.isArray(n) || Uo(n) || (t => ke(t) && Pc in t)(n)) {
        return n;
    }
    let e = Rc.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new qc(t, n));
        Rc.set(n, e);
    }
    return e;
};

class qc {
    $;
    Me;
    constructor(t, n) {
        this.$ = t;
        this.Me = n;
    }
    get(t, n, e) {
        if (n === Pc) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.Me.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.Me[o];
        const i = this.Me[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = Hu(c, r, i);
        Reflect.set(t, n, l);
        this.Me[o] = 0;
        this.Me[o + 1] = l;
        kc(r) && Ec(c, l, r, i);
        return l;
    }
    has(t, n) {
        if (n === Pc) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === Pc) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.Me.length / 2) {
            return o;
        }
        const i = r * 2;
        this.Me[i] = 0;
        this.Me[i + 1] = e;
        return !0;
    }
}

async function Kn(t) {
    const n = ju(null, null, () => "", () => {}, new WeakMap);
    n.St(t);
    await n.It();
    return n.Nt.toString();
}

function Zn(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = ne(n);
    return Qn(e, n[0], n[1]);
}

function te(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function ne(t) {
    let n;
    const e = {
        _: t => te(t, n),
        Ct: t => e.Rt?.[+t],
        getSyncFn: () => () => {},
        dt: new WeakMap,
        element: null,
        Rt: null
    };
    On(t, e);
    n = Tc(e, t);
    e.Ot = n;
    return e;
}

const Mc = (t, n) => {
    const e = new WeakSet;
    return lf(Ac, t, e, "_", n);
};

const Ac = (t, n, e, s) => {
    const o = bu(t);
    if (o == null) {
        return t;
    }
    if (Ic(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (iu(o)) {
            return t;
        }
        if (Fu(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (Ps(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (Re(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw qe(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw qe(3, [ o ]);
                    }
                    Ac(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof Rr) {
                return t;
            }
            if (Se(o)) {
                for (const [t, s] of Object.entries(o)) {
                    Ac(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw qe(3, [ i ]);
    }
    return t;
};

const xc = /*#__PURE__*/ new WeakSet;

const Ic = t => {
    if (ke(t) || Te(t)) {
        return !xc.has(t) && !(Oc in t);
    }
    return !0;
};

const Nc = t => !!t && (ke(t) || typeof t === "function") && (xc.has(t) || Oc in t);

const Cc = t => {
    (ke(t) && t !== null || typeof t === "function") && xc.add(t);
    return t;
};

const Oc = Symbol();

const jc = Symbol();

const Lc = t => /*#__PURE__*/ Object.freeze({
    id: Cs(t)
});

const Fc = (t, n) => {
    const {val: e, set: s, iCtx: o} = wo();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o.m, t, n);
    s(1);
};

const Xc = (t, n) => {
    const {val: e, set: s, iCtx: o} = wo();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o.m, t);
    if (typeof n === "function") {
        return s(ce(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw qe(8, [ t.id ]);
};

const Dc = t => {
    const n = sf();
    const e = n.m;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const Wc = /*#__PURE__*/ Lc("qk-error");

const xh = (t, n = t => t.boundary.pending.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const Nh = new WeakMap;

class Ch {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = Oh(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return xh(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const Oh = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const jh = () => {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    const t = ef()?.$;
    return t?.outOfOrderStreaming === !0 && !Mh(t);
};

const Vc = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && fu(t, n, r);
};

const Uc = new WeakMap;

const zc = (t, n) => {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`${Hc(e.Te)}${Ve}`);
    const o = Bc(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(kh) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        Jc(t, e, i.textContent);
    }
};

const Bc = t => {
    let n = Uc.get(t);
    if (!n) {
        n = new WeakSet;
        Uc.set(t, n);
    }
    return n;
};

const Hc = t => `script[type="qwik/state"][q\\:instance="${t}"]`;

const Jc = (t, n, e) => {
    if (e) {
        const [s, o, r, i] = JSON.parse(e);
        Qc(t, n, s, o);
        Yc(n, r || void 0);
        ((t, n) => {
            if (!__EXPERIMENTAL__.suspense || !n) {
                return;
            }
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                const o = t._(s.rootId);
                const r = s.subscriptions;
                if (o instanceof Ur) {
                    r instanceof Set && Vc(t, o, o, o.ct ||= new Set, r);
                } else {
                    if (!(r instanceof Map)) {
                        continue;
                    }
                    const n = $u(o);
                    const e = yu(o);
                    if (!n || !e) {
                        continue;
                    }
                    const s = n.ct ||= new Map;
                    for (const [o, i] of r) {
                        let r = s.get(o);
                        if (!r) {
                            r = new Set;
                            s.set(o, r);
                        }
                        Vc(t, n, e, r, i);
                    }
                }
            }
        })(t, i === void 0 ? void 0 : n._(i));
    }
};

const Qc = (t, n, e, s) => {
    const o = n.Ae.length / 2;
    if (e !== o) {
        return;
    }
    for (let t = 0; t < s.length; t++) {
        n.Ae[e * 2 + t] = s[t];
    }
    On(n.Ae, t, 0, e * 2);
    n.xe = Tc(t, n.Ae);
    n.xe.length = n.Ae.length / 2;
    n.Ie = n.Rt;
};

const Yc = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.Ie ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Rt = e;
};

function ee(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const m = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const w = t => {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.suspense && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && w(s);
        }
    };
    const b = t => {
        const n = m.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.suspense && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const _ = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const v = (n, e, s, o, r, i, c, l) => {
        const u = __EXPERIMENTAL__.suspense && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let m = 0;
        let w = 0;
        let g = -1;
        let S = null;
        const k = () => {
            let t = 0;
            for (;Gc(w = r.charCodeAt(y)); ) {
                t += 1 << w - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        do {
            if (s === o) {
                return;
            }
            S = null;
            const R = s == e ? 2 : b(s);
            if (R === 3) {
                const t = s;
                let e = s;
                for (;e && !(S = _(e)); ) {
                    e = e.parentNode;
                }
                v(n, t, s, S, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (R === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (R === 64) {
                S = s;
                let t;
                do {
                    S = n.nextNode();
                    if (!S) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(S);
                } while (t !== 32 && t !== 65);
                S = null;
            } else if (R === 9) {
                S = s;
                do {
                    S = _(S);
                    if (!S) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(S) !== 8);
                v(n, s, s, S, "", null, c);
            } else if (R === 6) {
                S = _(s);
                const n = s;
                const e = n?.shadowRoot;
                e && v(t.createTreeWalker(e, 129), null, e, null, "", null, null);
            }
            if ((R & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = m;
                    if (y < f) {
                        p += k();
                        if (w === 126) {
                            g = p;
                            y++;
                            w = y < f ? r.charCodeAt(m) : 33;
                        }
                        m = Kc(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.suspense && !u && R === 130 ? $.call(s, a) : null;
                if (h === p) {
                    g !== h || u && s === e || i.set(u ? je(l, h) : h, s);
                    const t = r.substring(y, m);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== Oe || n.charCodeAt(1) !== Oe || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.suspense && t !== null) {
                    E(c, s, t);
                    S = _(s);
                    S && (n.currentNode = S);
                }
            }
        } while (s = S || n.nextNode());
    };
    const g = (n, e, s, o) => {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        v(r, e, e, _(e), s, n.qVNodeRefs, n, o);
    };
    const E = __EXPERIMENTAL__.suspense ? (t, n, e, s) => {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && g(t, n, s, e);
    } : null;
    h.qProcessVNodeDataPatch = t => {
        const n = t?.closest("[q\\:container]");
        const e = t?.getAttribute("q:r");
        const s = n && (e ? n.querySelector(`[q\\:rp="${e}"]`) : n);
        n && s && g(n, s, t.textContent, e || void 0);
    };
    if (__EXPERIMENTAL__.suspense && n !== void 0) {
        if (e && s && o) {
            e.qVNodeRefs ||= new Map;
            E(e, s, n, o);
        }
        return;
    }
    w(t);
    const S = t.createTreeWalker(t, 129);
    v(S, null, S.firstChild(), null, "", null, null);
}

const Gc = t => 33 <= t && t <= 46;

const Kc = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Gc(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function se(t) {
    const n = ie(t);
    if (!n) {
        throw qe(24);
    }
    return re(n);
}

function re(t) {
    const n = t;
    return n.qContainer ||= new Zc(n);
}

function ie(t) {
    return t.closest(os);
}

function oe(t, n) {
    const e = t + "";
    const s = n?.closest(os);
    const o = s?.qContainer;
    if (o) {
        (function t(n, e, s) {
            if (!__EXPERIMENTAL__.suspense || !s) {
                return;
            }
            const o = s.closest("[q\\:container]");
            const r = o?.querySelector(`script[type="qwik/vnode"][q\\:r="${e}"]:not([q\\:patch])`);
            ee(n, e, o, s, r?.textContent || void 0);
            const i = o?.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${e}"][q\\:patch]`);
            for (let t = 0; i && t < i.length; t++) {
                n.qProcessVNodeDataPatch?.(i[t]);
            }
        })(o.element.ownerDocument, e, n);
        zc(o, e);
    }
}

class Zc extends ic {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    dt=new WeakMap;
    Ne;
    Te;
    Rt=null;
    vNodeLocate=t => il(this.rootVNode, t);
    Ae;
    xe;
    Ie=null;
    Ce=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(es);
        if (!this.qContainer) {
            throw qe(25);
        }
        this.document = t.ownerDocument;
        this.element = t;
        this.qe = t.getAttribute(Ge);
        this.Te = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = Do(this.element);
        this.Ae = [];
        this.xe = [];
        const n = this.element.ownerDocument;
        n.qVNodeDataProcessed || function e(t) {
            ee(t);
            t.qVNodeDataProcessed = !0;
        }(n);
        __EXPERIMENTAL__.suspense && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= oe);
        this.Ne = Ye(n, this.Te) || ti;
        this.Oe();
        t.setAttribute(es, "resumed");
        t.qContainer = this;
        t.qDestroy = () => this.Tn();
        this.je();
        __EXPERIMENTAL__.suspense && zc(this);
        this.Le();
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    Tn() {
        this.vNodeLocate = () => null;
        this.Ae.length = 0;
        this.xe.length = 0;
        this._ = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.suspense && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(es);
        const n = t.ownerDocument;
        const e = n.querySelector(os) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.suspense && (e || (n.qProcessOOOS = void 0));
    }
    je() {
        const t = this.element.querySelector(`${this.Fe()}:not(${Ve})`);
        if (t) {
            this.Ae = JSON.parse(t.textContent);
            On(this.Ae, this);
            this.Ie = this.Rt;
            this.xe = Tc(this, this.Ae);
        }
    }
    Fe() {
        return `script[type="qwik/state"][q\\:instance="${this.Te}"]`;
    }
    Le() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(Be);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    xn(t, n) {
        this.xe[t] = n;
    }
    parseQRL(t) {
        const n = Nn(t, this);
        return n;
    }
    handleError(t, n) {
        const e = n && this.resolveContext(n, Wc);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, Je);
        s == null && this.setHostProp(t, Je, s = []);
        _e(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, Je);
            if (e != null && Ee(e, n.id, 0)) {
                return ge(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (Qo(n)) {
                if (Go(n, Le, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        Ko(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case ps:
          case ds:
          case Le:
          case Je:
          case Qe:
          case rs:
            s = this._;
            break;

          case $s:
          case vs:
            s = parseInt;
            break;
        }
        return Go(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    _=t => te(t, this.xe);
    Ct(t) {
        return this.Ie?.[t];
    }
    getSyncFn(t) {
        const n = this.Ne[t];
        return n;
    }
    Xe(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, He);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, He, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.Ce == null) {
            this.Ce = new Set;
            const t = this.document.querySelectorAll(ze);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.Ce.add(e.getAttribute(Ue));
            }
        }
        if (!this.Ce.has(n)) {
            this.Ce.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(Ue, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Oe() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === Es) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.Dt = {
            containerAttributes: t
        };
    }
}

let tf;

let Lh;

if ($e) {
    const t = sc();
    t && (Lh = new t);
}

function le(t) {
    if (Lh) {
        const t = Lh.getStore();
        if (t) {
            return t;
        }
    }
    if (tf === void 0) {
        const n = ef();
        if (n && n.jt) {
            return n.jt;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return tf;
}

function ue(t, n) {
    if (Lh) {
        return Lh.run(t, n);
    }
    const e = tf;
    try {
        tf = t;
        return n();
    } finally {
        tf = e;
    }
}

let nf;

const ef = () => nf;

const sf = () => {
    const t = ef();
    if (!t) {
        throw qe(9);
    }
    return t;
};

const rf = () => {
    const t = ef();
    if (!t || t.Lt !== fs) {
        throw qe(10);
    }
    return t;
};

function ce(t, n, ...e) {
    return fe.call(this, t, n, e);
}

function fe(t, n, e) {
    const s = nf;
    try {
        nf = t;
        return n.apply(this, e);
    } finally {
        nf = s;
    }
}

const of = (t, n) => {
    const e = se(n);
    const s = il(e.rootVNode, n);
    const o = e.jt;
    o && function r(t) {
        if (Lh) {
            Lh.enterWith(t);
            return;
        }
        tf = t;
    }(o);
    const i = he(o, s, t);
    i.$ = e;
    return i;
};

function ae(t, n, e) {
    const s = {
        m: n,
        Lt: fs,
        Ft: void 0,
        jt: t,
        $: e,
        Xt: void 0
    };
    return s;
}

function he(t, n, e) {
    const s = t || (e && ke(e) && "locale" in e ? e.locale : void 0);
    const o = {
        m: n,
        Lt: e,
        Ft: void 0,
        jt: s,
        $: void 0
    };
    return o;
}

const lf = (t, ...n) => {
    if (typeof t === "function") {
        if (!nf) {
            return t(...n);
        }
        {
            const e = nf.Ft;
            try {
                nf.Ft = void 0;
                return t(...n);
            } finally {
                nf.Ft = e;
            }
        }
    }
    if (iu(t)) {
        return t.untrackedValue;
    }
    return bu(t);
};

const uf = /*#__PURE__*/ ae(void 0, void 0, void 0);

const cf = (t, n, e, s, o) => {
    const r = uf.Ft;
    const i = uf.$;
    try {
        uf.Ft = m(n, e, o);
        uf.$ = s;
        return fe(uf, t);
    } finally {
        uf.Ft = r;
        uf.$ = i;
    }
};

const ff = (t, n, e, s, o) => {
    t instanceof ki && t.m !== n && n && (t.m = n);
    return cf(() => t.value, n, e, s, o);
};

const af = () => ef()?.m;

const hf = () => {
    const t = ef();
    if (t) {
        return t.Lt;
    }
};

const df = () => {
    const t = ef();
    if (t) {
        return t.$;
    }
};

const pf = t => t;

const $f = t => t.l || Promise.resolve();

let yf = (t, n, e, s, o) => new mf(t, n, e, s, o);

class mf {
    _t;
    vt;
    De;
    We;
    $;
    constructor(t, n, e, s, o) {
        this._t = t;
        this.vt = n;
        this.De = e;
        this.We = s;
        s && this.Ve(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        ye && t && pe(t, .8);
    }
    get it() {
        return Sh(this.vt);
    }
    Ve(t) {
        this.We = t;
        Ps(t) && t.then(t => this.We = t, t => {
            console.error(`qrl ${this.vt} failed to load`, t);
            this.We = null;
        });
    }
    Ue() {
        if (this.We != null) {
            return this.We;
        }
        if (this._t === "") {
            const t = this.$.Te;
            const n = this.$.element?.ownerDocument || document;
            const e = Ye(n, t);
            return this.We = e[+this.vt];
        }
        ye && this._t && pe(this._t, 1);
        const t = this.vt;
        const n = this.De ? this.De().then(n => n[t]) : Hs().importSymbol(this.$?.element, this._t, t);
        this.Ve(n);
        return this.We;
    }
}

ye && import.meta.hot && (t => {
    if (!ye || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        yf = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t._t;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t._t;
            if (i) {
                t._t = e(i, o);
                r = !0;
            }
            const c = t.De?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.De = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.vt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.vt}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.We = void 0;
                document.__hmrDone = document.__hmrT;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    });
})(mf);

const wf = Symbol();

const bf = t => t?.[wf] ?? t;

class vf {
    ze;
    resolved=void 0;
    Mt;
    $;
    constructor(t, n, e) {
        this.ze = t;
        if (n) {
            this.Mt = n;
            typeof n === "string" && (this.$ = e);
        }
        t.We == null || typeof this.Mt === "string" || Ps(t.We) || (this.resolved = Tf(this, t.We));
    }
}

const _f = function(t, ...n) {
    const e = bf(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = ef();
    return gf.call(e, s?.$).then(() => fe.call(t, s, e.resolved, n));
};

const gf = async function(t) {
    const n = bf(this);
    return qs(qf(n, t), () => n.resolved);
};

const Ef = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[wf].resolved;
        },
        set(t) {
            this[wf].resolved = t;
        }
    },
    Mt: {
        get() {
            return this[wf].Mt;
        },
        set(t) {
            this[wf].Mt = t;
        }
    },
    $: {
        get() {
            return this[wf].$;
        },
        set(t) {
            this[wf].$ = t;
        }
    },
    ze: {
        get() {
            return this[wf].ze;
        }
    },
    _t: {
        get() {
            return this[wf].ze._t;
        }
    },
    vt: {
        get() {
            return this[wf].ze.vt;
        }
    },
    it: {
        get() {
            return this[wf].ze.it;
        }
    },
    dev: {
        get() {
            return this[wf].ze.dev;
        }
    },
    Be: {
        value: _f
    },
    w: {
        value: function(t) {
            const n = bf(this);
            const e = new vf(n.ze, t, n.Mt ? n.$ : void 0);
            return Af(e);
        }
    },
    s: {
        value: function(t) {
            const n = bf(this);
            n.ze.Ve(t);
            n.resolved = Tf(n, t);
        }
    },
    resolve: {
        value: gf
    },
    getSymbol: {
        value: function() {
            return bf(this).ze.vt;
        }
    },
    getHash: {
        value: function() {
            return bf(this).ze.it;
        }
    },
    getCaptured: {
        value: function() {
            const t = bf(this);
            Pf(t);
            return t.Mt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = bf(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return gf.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return fe(t, e.resolved, o);
            };
            return s;
        }
    }
});

let Sf = null;

const kf = t => {
    Sf = t;
};

const Rf = (t, n) => {
    const e = [];
    const s = n.split(" ");
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        e.push(t._(o));
    }
    return e;
};

const Pf = t => {
    Sf = t.Mt;
    const n = t.$;
    if (typeof Sf === "string") {
        if (!n) {
            throw qe(13);
        }
        const e = vc;
        Sf = t.Mt = Rf(n, Sf);
        if (vc !== e) {
            return vc;
        }
    }
};

const Tf = (t, n) => {
    if (typeof n !== "function" || !t.Mt) {
        return n;
    }
    return function e(...s) {
        Pf(t);
        return n.apply(this, s);
    };
};

const qf = (t, n) => {
    const e = t.ze;
    const s = typeof t.Mt === "string";
    s && !t.$ && (t.$ = n || ef()?.$);
    if (t.resolved) {
        return;
    }
    const o = Cf();
    const r = ef();
    const i = e.Ue();
    const c = qs(i, n => {
        t.resolved = Tf(t, n);
    });
    if (c) {
        const t = e.vt;
        If(t, r?.m instanceof Tr ? r?.m.node : void 0, o);
    }
    const l = s && t.$ && Pf(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const Mf = (t, n, e, s, o, r) => {
    const i = yf(t, n, s, e, r);
    const c = new vf(i, o, r);
    return Af(c);
};

const Af = t => {
    const n = async function(...t) {
        return _f.call(n, this, ...t);
    };
    n[wf] = t;
    Object.setPrototypeOf(n, Ef);
    return n;
};

const xf = /*#__PURE__*/ new Set;

const If = (t, n, e) => {
    if (!xf.has(t)) {
        xf.add(t);
        Nf("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const Nf = (t, n) => {
    Ph() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const Cf = () => {
    if (Ph()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let Of = 0;

const jf = t => Mf(null, "s" + Of++, t, null, null);

const Lf = jf;

const Ff = t => t;

const Xf = t => Mf("", Me, t, null, null);

const Df = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return Mf("", Me, t, null, null);
};

const Wf = t => {
    function n(n, e, s = 0) {
        const o = t.it.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[Vf] = [ t ];
        return Xi(i, n, null, n.children, s, r);
    }
    n[Vf] = [ t ];
    return n;
};

const Vf = Symbol();

const Uf = t => typeof t == "function" && t[Vf] !== void 0;

const zf = t => Wf(Lf(t));

const Bf = fi(Ff);

const Hf = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const Jf = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !br(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(es, "resumed");
    const s = se(t);
    s.Dt = e.serverData || {};
    const o = s.rootVNode;
    Ko(o, Nr, n);
    hn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            Et(s, [], s.rootVNode);
        }
    };
};

const Qf = (t, n) => {
    const {val: e, set: s, iCtx: o} = wo();
    if (e != null) {
        return e;
    }
    const r = Te(t) ? ce(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = _u(r, i, t);
        s(c);
        return c;
    }
};

const Yf = () => {
    const {val: t, set: n, iCtx: e} = wo();
    if (t != null) {
        return t;
    }
    const s = e.$.qe || "";
    const o = s ? Ls(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e.m, Le);
    const i = r?.getHash().substring(0, 3) || "";
    const c = (t => {
        const n = (t => {
            const n = t.Re;
            return n || t;
        })(t);
        return (t => t.toString(36))(n.Pe++);
    })(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function de(t, n) {
    const e = ef();
    return e?.$?.Dt[t] ?? n;
}

const Gf = /*#__PURE__*/ new Map;

const Kf = (t, n) => {
    let e = Gf.get(n);
    e || Gf.set(n, e = Zf(t, n));
    return e;
};

const Zf = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = ra;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === Aa) {
            r++;
            e = Ta;
        }
        const s = Fa[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, m] = p;
            if (($ === l || $ === da || $ === pa && ta(l) || $ === ya && sa(l)) && (y === e || y === da || y === pa && ta(e) || y === $a && !ta(e) && e !== Sa || y === ya && sa(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (m === aa || m == ha) {
                    if (m === ha) {
                        if (c !== ia || h()) {
                            if (!na(e)) {
                                const t = y == $a ? 1 : y == ga ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            na(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === $a) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || ra;
                        if (c === oa) {
                            u(r - 1);
                            i++;
                        }
                    } while (ea(c));
                } else {
                    o.push(c);
                    if (c === oa && m === ra) {
                        u(r - 8);
                        i = r;
                    } else {
                        m === la && f(n);
                    }
                    c = m;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === oa || h()) {
            return;
        }
        u(t);
        s.push(".", Xe, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === Ea) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === Ea) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | Ia) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(oa) !== -1 || o.indexOf(ua) !== -1;
    }
};

const ta = t => t >= ka && t <= Ra || t >= Ta && t <= qa || t >= Na && t <= Ca || t >= 128 || t === xa || t === Ea;

const na = t => t === Pa || t === Sa || t === Ma || t === _a || ta(t);

const ea = t => t === ca || t === ua || t === fa || t === oa;

const sa = t => t === va || t === ma || t === wa || t === ba;

const ra = 0;

const ia = 2;

const oa = 5;

const la = 6;

const ua = 10;

const ca = 11;

const fa = 12;

const aa = 17;

const ha = 18;

const da = 0;

const pa = 1;

const $a = 2;

const ya = 3;

const ma = 9;

const wa = 10;

const ba = 13;

const va = 32;

const _a = 35;

const ga = 41;

const Ea = 45;

const Sa = 46;

const ka = 48;

const Ra = 57;

const Pa = 58;

const Ta = 65;

const qa = 90;

const Ma = 91;

const Aa = 92;

const xa = 95;

const Ia = 32;

const Na = 97;

const Ca = 122;

const Oa = 123;

const ja = 125;

const La = /*@__PURE__*/ (() => [ [ da, 39, 14 ], [ da, 34, 15 ], [ da, 47, 16, "*" ] ])();

const Fa = /*@__PURE__*/ (() => [ [ [ da, 42, ia ], [ da, Ma, 7 ], [ da, Pa, la, ":", "before", "after", "first-letter", "first-line" ], [ da, Pa, oa, "global" ], [ da, Pa, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ da, Pa, 4 ], [ da, pa, 1 ], [ da, Sa, 1 ], [ da, _a, 1 ], [ da, 64, ua, "keyframe" ], [ da, 64, ca, "media", "supports", "container" ], [ da, 64, fa ], [ da, Oa, 13 ], [ 47, 42, 16 ], [ da, 59, aa ], [ da, ja, aa ], [ da, ga, aa ], ...La ], [ [ da, $a, ha ] ], [ [ da, $a, ha ] ], [ [ da, 40, ra ], [ da, $a, ha ] ], [ [ da, 40, 8 ], [ da, $a, ha ] ], [ [ da, 40, ra ], [ da, $a, aa ] ], [ [ da, $a, aa ] ], [ [ da, 93, ha ], [ da, 39, 14 ], [ da, 34, 15 ] ], [ [ da, ga, aa ], ...La ], [ [ da, ja, aa ], ...La ], [ [ da, ja, aa ], [ ya, pa, 1 ], [ da, Pa, oa, "global" ], [ da, Oa, 13 ], ...La ], [ [ da, Oa, ra ], [ da, 59, aa ], ...La ], [ [ da, 59, aa ], [ da, Oa, 9 ], ...La ], [ [ da, ja, aa ], [ da, Oa, 13 ], [ da, 40, 8 ], ...La ], [ [ da, 39, aa ] ], [ [ da, 34, aa ] ], [ [ 42, 47, aa ] ] ])();

const Xa = t => ({
    styleId: Ua(t, t => t, !1)
});

const Da = /*#__PURE__*/ fi(Xa);

const Wa = t => ({
    scopeId: Xe + Ua(t, Kf, !0)
});

const Va = /*#__PURE__*/ fi(Wa);

const Ua = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = wo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${Ls(t.it)}-${n}`)(t, i);
    const l = r.m;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.Xe(n(t, c), c, l, e));
    }
    r.$.Xe(n(t.resolved, c), c, l, e);
    return c;
};

const za = (t, n) => {
    t.resolve();
    return hi(t, n);
};

const Ba = (t, n) => _o(za, t, n);

const Ha = fi(Ba);

const Ja = t => {
    t.resolve();
    return pi(t);
};

const Qa = t => _o(Ja, t);

const Ya = fi(Qa);

const Ga = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = wo();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !Ph()) {
            e.h |= 32;
            Ka(e, i);
        }
        return;
    }
    let c;
    if (Ph()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        hn(r.$, r.m, 1);
    }
    const l = new eu(c, o, r.m, t, void 0, null);
    s(l);
    Ka(l, i);
};

const Ka = (t, n) => {
    n === "intersection-observer" ? dc("qvisible", Za(t)) : n === "document-ready" ? pc("qinit", Za(t)) : n === "document-idle" && pc("qidle", Za(t));
};

const Za = t => Mf(null, "_task", Rn, null, [ t ]);

const th = fi(fc);

const nh = /*#__PURE__*/ fi(tu);

const eh = /*#__PURE__*/ fi(Ga);

const sh = (t, n) => {
    t.resolve();
    return di(t, n);
};

const rh = (t, n) => _o(sh, t, n);

const ih = fi(rh);

const oh = () => {
    const t = Qf({
        error: void 0
    });
    Fc(Wc, t);
    return t;
};

const lh = async ({track: t}) => {
    const n = Sf[0];
    t(() => n.items);
    const e = ef();
    const s = e.m;
    const o = e.$;
    hn(o, s, 256);
    const r = $e;
    r && await o.l;
};

const uh = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    tu(/*#__PURE__*/ Qu(lh, "_eaT", [ t ]));
    return Gi;
};

const ch = /*#__PURE__*/ Wf(
/*#__PURE__*/ Qu(uh, "_eaC"));

const fh = /*#__PURE__*/ Lc("qk-reveal");

const ah = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: $i(0)
});

const hh = () => {
    const t = Sf[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!ye) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return xh(t);
};

const dh = ({cleanup: t}) => {
    const n = Sf[0];
    t(() => {
        if (!ye) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const ph = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = _o(ah, t);
    Fc(fh, n);
    const e = !ye;
    if (__EXPERIMENTAL__.suspense && e && jh()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                if (!jh()) {
                    return null;
                }
                const e = ef()?.$;
                let s = 0;
                if (e) {
                    s = (Nh.get(e) || 0) + 1;
                    Nh.set(e, s);
                }
                return new Ch(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = Cc(e);
            return e;
        })(n);
        /*#__PURE__*/
        return Fi(Fh, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    /*#__PURE__*/
    return Fi(Yi, null, null, null, 0, "u7_0");
};

const $h = /*#__PURE__*/ Wf(
/*#__PURE__*/ Qu(ph, "_reC"));

const Fh = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Ih((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ Fi(Yi, null, null, null, 0, "u7_0"));
}) : null;

const yh = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || e !== null && !e.value && s.reveal.collapsed ? "none" : "contents"
});

const Xh = '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2===null||p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const mh = (t, n, e) => ({
    display: n.value !== "content" && !t.showStale || e !== null && !e.value ? "none" : "contents"
});

const wh = ({track: t, cleanup: n}) => {
    const e = Sf[0], s = Sf[1], o = Sf[2], r = Sf[3];
    const i = t(e.pending);
    const c = ye;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.pending.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const bh = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = vo("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return _o(go);
    })();
    const s = (t => {
        const n = Xc(fh, null);
        const e = _o(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && tu(/*#__PURE__*/ Qu(dh, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = Ba(
    /*#__PURE__*/ Qu(hh, "_reR", [ s ]));
    tu(
    /*#__PURE__*/ Qu(wh, "_suT", [ e, t, n, s ]));
    const r = !ye;
    const i = r && jh();
    const c = i ? (() => {
        if (!__EXPERIMENTAL__.suspense) {
            return 0;
        }
        const t = ef()?.$;
        if (t?.outOfOrderStreaming !== !0) {
            return 0;
        }
        return t?.nextOutOfOrderId?.() ?? 0;
    })() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && function f(t, n) {
        return t != null && t !== !1 && (n === null || n.showFallback);
    }(t.fallback, l);
    const a = u && Vh(t.delay) ? {
        contentResolved: !1,
        delayTimer: null
    } : null;
    const h = i ? /*#__PURE__*/ rc(yh, [ t, n, o, s ], Xh) : null;
    const d = /*#__PURE__*/ rc(mh, [ t, n, o ], '{display:(p1.value==="content"||p0.showStale)&&(p2===null||p2.value)?"contents":"none"}');
    const p = i ? /*#__PURE__*/ Fi(Dh, {
        boundary: a,
        delay: t.delay,
        fallbackStyle: h,
        showFallback: u,
        state: n
    }, null, gi(t, "fallback"), 1, null) : /*#__PURE__*/ Fi("div", {
        style: rc(yh, [ t, n, o, s ], Xh)
    }, null, gi(t, "fallback"), 1, null);
    return [ p, 
    /*#__PURE__*/ Fi("div", null, i ? {
        [Rh]: c + "",
        style: d
    } : {
        style: d
    }, 
    /*#__PURE__*/ Fi(i ? Wh : Yi, i ? {
        [rs]: e,
        boundary: a,
        boundaryId: c,
        contentStyle: d,
        reveal: l
    } : {
        [rs]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const vh = /*#__PURE__*/ Wf(
/*#__PURE__*/ Qu(bh, "_suC"));

const Dh = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Ih((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.delay;
    const i = n.varProps.fallbackStyle;
    const c = n.varProps.showFallback === !0;
    const l = n.varProps.state;
    c && !Vh(r) ? l.value = "fallback" : o && c && Vh(r) && s(() => function n(t, e, s, o) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.S(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, o);
    }(t, o, l, r));
    s(
    /*#__PURE__*/ Fi("div", {
        style: i
    }, null, n.children, 1, null));
}) : null;

const Wh = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Ih(async (t, n, e) => {
    const s = n.varProps.boundaryId ?? t.nextOutOfOrderId();
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = t.segment(o, function u(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            /*#__PURE__*/
            return Fi(Yi, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = k(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        /*#__PURE__*/
        return Fi(Yi, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    (function f(t, n) {
        t.write(`<template ${kh}="${n}"></template>`);
    })(t, s);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(l.then(n => async function e(t, n, s, o, r, i, c) {
        (function l(t) {
            if (!t) {
                return;
            }
            t.contentResolved = !0;
            if (t.delayTimer) {
                clearTimeout(t.delayTimer);
                t.delayTimer = null;
            }
        })(c);
        i?.resolve();
        await t.S(async () => {
            t.addRoot(r);
            const e = await o.container.P(s, o);
            (function c(t, n, e, s) {
                t.write(`<template ${kh}="${n}"${s?.attrs ?? ""}>`);
                t.write(e);
                t.write("</template>");
            })(t, n, e.html, i);
            t.emitOutOfOrderSegmentScripts(e.scripts);
            t.emitInlineScript(`qO(${n})`);
            await t.streamHandler.flush();
        });
    }(t, s, o, n, i, c, r)));
}) : null;

function Vh(t) {
    return typeof t === "number" && Number.isFinite(t) && t > 0;
}

const _h = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = gh.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return Fi("script", null, o, null, 0, "prefetch-service-worker");
};

const gh = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const Eh = () => null;

globalThis.__qwik && qe(30, [ globalThis.__qwik, wr ]);

globalThis.__qwik = wr;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { jf as $, ch as Each, Ji as Fragment, Oc as NoSerializeSymbol, Eh as PrefetchGraph, _h as PrefetchServiceWorker, Qi as RenderOnce, ac as Resource, $h as Reveal, Zi as SSRComment, Ki as SSRRaw, no as SSRStream, to as SSRStreamBlock, jc as SerializerSymbol, Gi as SkipRender, Yi as Slot, vh as Suspense, Jr as _CONST_PROPS, Zc as _DomContainer, vr as _EFFECT_BACK_REF, ti as _EMPTY_ARRAY, ni as _EMPTY_OBJ, Kr as _IMMUTABLE, ic as _SharedContainer, Ri as _SubscriptionData, Pu as _SubscriptionPatch, Zr as _UNINITIALIZED, Qr as _VAR_PROPS, zn as _addProjection, Sf as _captures, v as _chk, ne as _createDeserializeContainer, Mf as _createQRL, Zn as _deserialize, Wu as _dumpState, uh as _eaC, lh as _eaT, fn as _executeSsrChores, rc as _fnSignal, sc as _getAsyncLocalStorage, ui as _getConstProps, df as _getContextContainer, hf as _getContextEvent, af as _getContextHostElement, se as _getDomContainer, ie as _getQContainerElement, li as _getVarProps, wu as _hasStoreEffects, wc as _hmr, qi as _isJSXNode, vu as _isStore, Ln as _isStringifiable, su as _isTask, pf as _jsxBranch, Di as _jsxC, Vi as _jsxQ, Wi as _jsxS, Fi as _jsxSorted, Xi as _jsxSplit, ve as _mapApp_findIndx, ge as _mapArray_get, _e as _mapArray_set, Yu as _noopQrl, Gu as _noopQrlDEV, On as _preprocessState, Df as _qrlSync, xn as _qrlToString, Ku as _qrlWithChunk, Zu as _qrlWithChunkDEV, ph as _reC, hh as _reR, dh as _reT, ec as _regSymbol, Jn as _removeProjection, _ as _res, Dc as _resolveContextWithoutSequentialScope, oo as _restProps, cc as _rsc, I as _run, Kn as _serialize, Wn as _setEvent, Bn as _setProjectionTarget, bh as _suC, wh as _suT, Rn as _task, Hn as _updateProjectionProps, Un as _useHmr, b as _val, Mc as _verifySerializable, nl as _vnode_ensureElementInflated, Ul as _vnode_getAttrKeys, El as _vnode_getElementName, Rl as _vnode_getFirstChild, Go as _vnode_getProp, ul as _vnode_getVNodeForChildNode, wl as _vnode_insertBefore, zo as _vnode_isElementVNode, Ho as _vnode_isMaterialized, Jo as _vnode_isTextVNode, Qo as _vnode_isVirtualVNode, Vo as _vnode_newVirtual, _l as _vnode_remove, Ko as _vnode_setProp, bn as _vnode_toString, $f as _waitUntilRendered, Xn as _walkJSX, gi as _wrapProp, Si as _wrapSignal, zf as component$, Wf as componentQrl, mi as createAsync$, di as createAsyncQrl, yi as createComputed$, hi as createComputedQrl, Lc as createContextId, g as createElement, wi as createSerializer$, pi as createSerializerQrl, $i as createSignal, Bf as event$, Ff as eventQrl, mu as forceStoreEffects, Hf as getClientManifest, se as getDomContainer, le as getLocale, Hs as getPlatform, g as h, fi as implicit$FirstArg, Qu as inlinedQrl, nc as inlinedQrlDEV, me as isDev, iu as isSignal, zi as jsx, Bi as jsxDEV, Hi as jsxs, Cc as noSerialize, Ju as qrl, tc as qrlDEV, Jf as render, Bs as setPlatform, Xf as sync$, lf as untrack, bu as unwrapStore, ih as useAsync$, rh as useAsyncQrl, Ha as useComputed$, Ba as useComputedQrl, _o as useConstant, Xc as useContext, Fc as useContextProvider, oh as useErrorBoundary, Yf as useId, uc as useLexicalScope, dc as useOn, pc as useOnDocument, $c as useOnWindow, th as useResource$, fc as useResourceQrl, Ya as useSerializer$, Qa as useSerializerQrl, de as useServerData, vo as useSignal, Qf as useStore, Da as useStyles$, Xa as useStylesQrl, Va as useStylesScoped$, Wa as useStylesScopedQrl, nh as useTask$, tu as useTaskQrl, eh as useVisibleTask$, Ga as useVisibleTaskQrl, wr as version, ue as withLocale };
